import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Navbarh from "../navbar/Navbar";
//import { API } from "aws-amplify";
import "../estilos.css";
import {
  listRecibaSeriales,
  listEmbarques,
  listEmbarqueSeriales,
  listEmbarqueUltimoNumeros,
  listClientes,
  listUbicacions,
} from "../../graphql/queries";
import {
  createEmbarque as createEmbarqueMutation,
  createEmbarqueUltimoNumero,
  createEmbarqueSeriales,
  createUbicacion,
  updateRecibaSeriales,
  updateEmbarqueUltimoNumero,
  updateEmbarqueSeriales,
  updateUbicacion,
  updateRecibaSerialesMP,
  createRecibaSerialesMP,
  updateEmbarque,
} from "../../graphql/mutations";
import * as IoIcons from "react-icons/io";
import Pagination from "react-js-pagination";
import Moment, { updateLocale } from "moment";
import classnames from "classnames";
import { useReactToPrint } from "react-to-print";
import Bargenerator from "../codereader/barcodegeneratorComp";
import { CSVLink, CSVDownload } from "react-csv";
import {
  GetClientes,
  GetClientesID,
  GetEmbarques,
  GetEmbarquesID,
  GetEmbarquesSeriales,
  GetEmbarquesSerialesID,
  GetProductosID,
  GetRecibaSeriales,
  GetRecibaSerialesID,
  GetUbicacion,
} from "../queries/Queries";
import { ObtenerSerialesEmbarques, ObtenerServiciosEmbarques, ObtenerServiciosFacturacion, combinarIDS } from "../queries/DCUbicaciones";
import FacturacionG from "./FacturacionG";
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: "Facturación" };

function Facturacion() {
  //Declaración de variables
  const [clientes, setClientes] = useState([]);
  const [embarquesSinFiltro, setEmbarquesSinFiltro] = useState([]);
  const [facturasSinFiltro, setFacturasSinFiltro] = useState([]);
  const [embarques, setEmbarques] = useState([]);
  const [datosIncompletos, setDatosIncompletos] = useState(false);
  const [facturados, setFacturados] = useState([]);
  const [editar, setEditar] = useState(false);
  const [embarqueEditando, setEmbarqueEditando] = useState("");
  const [numeroP, setNumeroP] = useState(0);
  const [ultimoNumeroP, setultimoNumeroP] = useState(0);
  const [totalNumeroParte, setTotalNumeroParte] = useState([]);
  const [sinTotalScrapFactura, setSinTotalScraptFactura] = useState(false);

  const [isDisabled, setisDisabled] = useState(false);

  const [search, setSearch] = useState("");
  const [searchEmbarque, setSearchEmbarque] = useState("");
  const [fechaPBusqueda, setFechaPBusqueda] = useState("");
  const [fechaPBusquedaEmbarque, setFechaPBusquedaEmbarque] = useState("");
  const [searchBy, setSearchBy] = useState("cliente");
  const [searchByEmbarque, setSearchByEmbarque] = useState("cliente");
  const [totalRecordsEmbarque, setTotalRecordsEmbarque] = useState(0);
  const { formType } = initialfFormState;
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const userName = window.$name;
  const pfacturacion = window.$Facturacion ? window.$Facturacion : false;
  const [tituloTab, setTituloTab] = useState(
    pfacturacion ? "Generar invoice" : "Detalle de invoice"
  );
  const [aVisible, setAVisible] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [clienteID, setClienteID] = useState("");
  const [rCliente, setRCliente] = useState("");
  const [clienteEntregaID, setClienteEntregaID] = useState("");
  const [aMRecuperado, setAMRecuperado] = useState(false);
  const [habilitarBRE, setHabilitarBRE] = useState(true);
  const [rClienteEntrega, setRClienteEntrega] = useState("");
  const [rClienteFacturarA, setRClienteFacturarA] = useState("");
  const [fechaFactura, setFechaFactura] = useState("");
  const [facturaDescuentoP, setFacturaDescuentoP] = useState("");
  const [requisitioner, setRequisitioner] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [posS, setPosS] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [comentariosFacturacion, setComentariosFacturacion] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [casQuote, setCasQuote] = useState("");
  const [invoiceID, setInvoiceID] = useState("");
  const [shipTo, setShipTo] = useState("");
  const [billTo, setBillTo] = useState("");
  const [fechaDeEmbarqueM, setFechaDeEmbarqueM] = useState("");
  const [sumCajas, setSumCajas] = useState("");
  const [sumContenedores, setSumContenedores] = useState("");
  const [sumTarimas, setSumTarimas] = useState("");
  const [sumTotal, setSumTotal] = useState("");
  const [sumSubTotal, setSubSumTotal] = useState("");
  const [sumTotalDes, setSumTotalDes] = useState("");
  const [sumTotalServicio, setSumTotalServicio] = useState("");
  const onDismiss = () => setAVisible(false);
  const [inputList, setInputList] = useState([]);
  const [inputListServicios, setInputListServicios] = useState([]);
  const [servicios, setServicios] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [paginas, setPaginas] = useState([]);
  const [paginasEmbarques, setPaginasEmbarques] = useState([]);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [indexImp, setIndexImp] = useState(0);
  const serviciosIniciales = { quantity: 0, description: "", uprice: 0.0, total: 0.0, createdAt: "", updatedAt: "", Reg_Ins_Usuario: userName, Reg_Mod_Usuario: "" }
  Moment.locale("en");
  var now = new Date();
  var now2 = new Date();
  now2.setMonth(now2.getMonth() - 1);
  now.setDate(now.getDate() + 5);
  const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
  const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));
  const aniosLetra = [
    { letra: "A", año: "2020" },
    { letra: "B", año: "2021" },
    { letra: "C", año: "2022" },
    { letra: "D", año: "2023" },
    { letra: "E", año: "2024" },
    { letra: "F", año: "2025" },
    { letra: "G", año: "2026" },
    { letra: "H", año: "2027" },
    { letra: "I", año: "2028" },
    { letra: "J", año: "2029" },
    { letra: "K", año: "2030" },
    { letra: "L", año: "2031" },
    { letra: "M", año: "2032" },
    { letra: "N", año: "2033" },
    { letra: "O", año: "2034" },
    { letra: "P", año: "2035" },
    { letra: "Q", año: "2036" },
    { letra: "R", año: "2037" },
    { letra: "S", año: "2038" },
    { letra: "T", año: "2039" },
    { letra: "U", año: "2040" },
    { letra: "V", año: "2041" },
    { letra: "W", año: "2042" },
    { letra: "X", año: "2043" },
    { letra: "Y", año: "2043" },
    { letra: "Z", año: "2045" },
  ];

  const toggle1 = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
    if (tab > 1) setAVisible(false);
  };
  //Se obtiene el año en letra que corresponde          
  const Anio = Moment(now).format("YYYY");
  const anioLetra = aniosLetra.filter((anio) => anio.año == Anio);
  const aLetra = anioLetra[0].letra ? anioLetra[0].letra : "NAN";

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const componentRefTEV = useRef();
  const handlePrintTEV = useReactToPrint({
    content: () => componentRefTEV.current,
  });

  const componentRef = React.useMemo(
    () =>
      Array(100)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );
  const handlePrint = useReactToPrint({
    content: () => componentRef[indexImp].current,
  });

  // current page
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageEmbarques, setCurrentPageEmbarques] = useState(1);


  // total records per page to display
  const recordPerPage = 20;
  const recordPerPageEmbarque = 20;

  // range of pages in paginator
  const pageRange = 5;
  //Método useEffect
  useEffect(() => {
    fetchFacturas(rfechaini, rfechafin);
    fetchEmbarques();
    fetchClientes();
  }, []);

  //Obtiene los datos guardados de los embarques
  async function fetchFacturas(fechainicial, fechafinal) {
    //Filtro por embarque activo y fecha
    setCargando(true);
    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          fechaDeFacturacion: {
            ge: fechainicial,
          },
        },
        {
          fechaDeFacturacion: {
            le: fechafinal,
          },
        },
        {
          or: [
            {
              serialesEID: {
                attributeExists: true,
              },
            },
            {
              servicioExtraEmbarques: {
                attributeExists: true,
              },
            },
          ]
        },
      ],
    };
    const apiData = await GetEmbarques(filter);
    const EmbarquesFromAPI = apiData.sort((a, b) =>
      a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0
    );
    await Promise.all(
      EmbarquesFromAPI.map(async (embarques) => {
        if (!embarques.clienteEntregaID) {
          embarques.clienteEntregaID = embarques.clienteID;
          embarques.clienteEntrega = embarques.cliente;
        }
        embarques.cantidadDisponible = 20000;
        return embarques;
      })
    );
    if (EmbarquesFromAPI.length > 0) {
      setFacturasSinFiltro(EmbarquesFromAPI);
      busqueFactura(
        EmbarquesFromAPI,
        searchBy,
        search,
        currentPage
      );
    } else {
      setFacturados([]);
    }
    setCargando(false);
  }

  //Obtiene los datos guardados de los embarques
  async function fetchEmbarques() {
    //Filtro por embarque activo y fecha
    setCargando(true);
    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          piezasEmbarcadas: {
            ge: 1,
          },
        },
        {
          or: [
            {
              facturado: {
                eq: false,
              },
            },
            {
              facturado: {
                attributeExists: false,
              },
            },
          ]
        },
        {
          or: [
            {
              serialesEID: {
                attributeExists: true,
              },
            },
            {
              servicioExtraEmbarques: {
                attributeExists: true,
              },
            },
          ]
        }
      ],
    };
    const apiData = await GetEmbarques(filter);
    const EmbarquesFromAPI = apiData.sort((a, b) =>
      a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0
    );
    await Promise.all(
      EmbarquesFromAPI.map(async (embarques) => {
        const restFechas = (new Date()).getTime() - (new Date(embarques.fechaDeEmbarque)).getTime();
        embarques.DiasEmbarques = Math.round(restFechas / (1000 * 60 * 60 * 24));
        if (!embarques.clienteEntregaID) {
          embarques.clienteEntregaID = embarques.clienteID;
          embarques.clienteEntrega = embarques.cliente;
        }
        embarques.cantidadDisponible = 20000;
        return embarques;
      })
    );
    if (EmbarquesFromAPI.length > 0) {
      setEmbarquesSinFiltro(EmbarquesFromAPI);
      busquedaEmbarques(
        EmbarquesFromAPI,
        searchByEmbarque,
        search,
        currentPageEmbarques
      );
    } else {
      setEmbarques([]);
    }
    setCargando(false);
  }

  //Obtiene los datos guardados de los clientes
  async function fetchClientes() {
    const clientesFromAPI = await GetClientes();
    setClientes(clientesFromAPI);
  }

  //Revisa cambios en el input de clientes
  function onChangesClientes(e) {
    e.persist();
    const ocClienteID = e.target.value;
    if (e.target.value != "") {
      const fClientes = clientes.filter(
        (fcliente) => fcliente.id === ocClienteID
      );
      setClienteID(fClientes[0].id);
      setRCliente(fClientes[0].cliente);
      setClienteEntregaID(fClientes[0].id);
      setRClienteEntrega(fClientes[0].cliente);
      setRClienteFacturarA(fClientes[0].cliente);
    } else {
      setClienteID("");
      setRCliente("");
      setClienteEntregaID("");
      setRClienteEntrega("");
      setRClienteFacturarA("");
    }
    //setBusquedaxClientes(ocClienteID);
    //cambioDatosEmbarque(e);
  }
  function buscarpor(e) {
    setAVisible(false);
    setSearchBy(e.target.value);
    if (search && e.target.value !== "fecha")
      busqueFactura(
        facturasSinFiltro,
        e.target.value,
        search,
        currentPage
      );
  }
  function buscarporEmbarque(e) {
    setAVisible(false);
    setSearchByEmbarque(e.target.value);
    if (search && e.target.value !== "fecha")
      busquedaEmbarques(
        embarquesSinFiltro,
        e.target.value,
        search,
        currentPage
      );
  }
  async function busqueFactura(embarquessf, searchb, search, currentPage) {
    var i = 1;
    var paginasp = [];
    var p = 1;
    var pi = 1;
    var racks = 0;

    const embarqueFromAPI = embarquessf
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      )
      .filter((embarque) =>
        searchb === "numero de parte"
          ? embarque.numerosdeParte.toLowerCase().includes(search.toLowerCase())
          : searchb === "cliente"
            ? embarque.cliente.toLowerCase().includes(search.toLowerCase())
            : searchb === "invoiceid"
              ? embarque.invoiceID.toLowerCase().includes(search.toLowerCase())
              : searchb === "serial"
                ? embarque.seriales.toLowerCase().includes(search.toLowerCase())
                : searchb === "paking"
                  ? embarque.packings.toLowerCase().includes(search.toLowerCase())
                  : searchb === "lote"
                    ? embarque.lotes.toLowerCase().includes(search.toLowerCase())
                    : Moment(embarque.fechaDeFacturacion)
                      .format("DD/MM/YYYY")
                      .includes(Moment(search).format("DD/MM/YYYY"))
      );

    await Promise.all(
      embarqueFromAPI.map(async (embarques) => {
        embarques.paginacion = pi;
        p++;
        if (p > recordPerPage) {
          p = 1;
          paginasp.push({ pagina: pi });
          pi++;
        }
        return embarques;
      })
    );

    const lengthEmbarque = embarqueFromAPI.length;
    if (lengthEmbarque <= 0) setCurrentPage(1);

    const embarquescp = embarqueFromAPI
      .filter((embarques) => embarques.paginacion === currentPage)
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      );
    if (embarquescp.length) {
      setFechaDeEmbarqueM(embarquescp[0].fechaDeEmbarques);
      setFacturados(embarquescp);
    }

    setTotalRecordsEmbarque(lengthEmbarque);
    const prepaginas = parseInt(lengthEmbarque / recordPerPage);
    const paginas =
      prepaginas * recordPerPage < lengthEmbarque
        ? prepaginas + 1
        : prepaginas;
    if (paginas > paginasp.length) paginasp.push({ pagina: paginas });

    if (currentPage > 1 && lengthEmbarque > 0) {
      if (currentPage > paginas) {
        setCurrentPage(paginas);
      }
    }

    if (lengthEmbarque > 0) {
      setPaginas(paginasp);
      setultimoNumeroP(paginasp[paginasp.length - 1].pagina);
    } else {
      setPaginas([]);
      setultimoNumeroP(0);
    }
  }
  async function busquedaEmbarques(embarquessf, searchb, search, currentPage) {
    var i = 1;
    var paginasp = [];
    var p = 1;
    var pi = 1;
    var racks = 0;

    const embarqueFromAPI = embarquessf
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      )
      .filter((embarque) => ((embarque.facturado ? embarque.facturado : false) === false) &&
        searchb === "numero de parte"
        ? embarque.numerosdeParte.toLowerCase().includes(search.toLowerCase())
        : searchb === "cliente"
          ? embarque.cliente.toLowerCase().includes(search.toLowerCase())
          : searchb === "id de embarque"
            ? embarque.numero.toString().includes(search.toLowerCase())
            : searchb === "serial"
              ? embarque.seriales.toLowerCase().includes(search.toLowerCase())
              : searchb === "paking"
                ? embarque.packings.toLowerCase().includes(search.toLowerCase())
                : searchb === "lote"
                  ? embarque.lotes.toLowerCase().includes(search.toLowerCase())
                  : Moment(embarque.fechaDeEmbarque)
                    .format("DD/MM/YYYY")
                    .includes(Moment(search).format("DD/MM/YYYY"))
      );

    await Promise.all(
      embarqueFromAPI.map(async (embarques) => {
        embarques.paginacion = pi;
        p++;
        if (p > recordPerPageEmbarque) {
          p = 1;
          paginasp.push({ pagina: pi });
          pi++;
        }
        return embarques;
      })
    );

    const lengthEmbarque = embarqueFromAPI.length;
    if (lengthEmbarque <= 0) setCurrentPageEmbarques(1);

    const embarquescp = embarqueFromAPI
      .filter((embarques) => embarques.paginacion === currentPage)
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      );
    if (embarquescp.length)
      setEmbarques(embarquescp);

    setTotalRecordsEmbarque(lengthEmbarque);
    const prepaginas = parseInt(lengthEmbarque / recordPerPageEmbarque);
    const paginas =
      prepaginas * recordPerPageEmbarque < lengthEmbarque
        ? prepaginas + 1
        : prepaginas;
    if (paginas > paginasp.length) paginasp.push({ pagina: paginas });

    if (currentPage > 1 && lengthEmbarque > 0) {
      if (currentPage > paginas) {
        setCurrentPageEmbarques(paginas);
      }
    }

    if (lengthEmbarque > 0) {
      setPaginasEmbarques(paginasp);
      setultimoNumeroP(paginasp[paginasp.length - 1].pagina);
    } else {
      setPaginasEmbarques([]);
      setultimoNumeroP(0);
    }
  }
  function onSearchFecha(e) {
    setAVisible(false);
    setSearch(e.target.value);
    busqueFactura(
      facturasSinFiltro,
      searchBy,
      e.target.value,
      currentPage
    );
  }
  function onSearch(e) {
    setAVisible(false);
    busqueFactura(
      facturasSinFiltro,
      searchBy,
      search,
      currentPage
    );
  }
  function onSearchFechaEmbarque(e) {
    setAVisible(false);
    setSearchEmbarque(e.target.value);
    busquedaEmbarques(
      embarquesSinFiltro,
      searchByEmbarque,
      e.target.value,
      currentPageEmbarques
    );
  }
  function onSearchEmbarque(e) {
    setAVisible(false);
    busquedaEmbarques(
      embarquesSinFiltro,
      searchByEmbarque,
      searchEmbarque,
      currentPageEmbarques
    );
  }
  //Revisa cambios en la fecha de búsqueda
  function onChangesRFechaini(e) {
    e.persist();
    var fechaini = rfechaini;
    var fechafin = rfechafin;
    if (e.target.name === "rFechaIni") {
      fechaini = e.target.value;
    } else {
      fechafin = e.target.value;
    }
    setRfechafin(fechafin);
    setRfechaini(fechaini);
    fetchFacturas(fechaini, fechafin);
  }
  //Obtiene los datos guardados de embarquesSeriales por el id de embarque
  async function fetchEmbarqueSerial(embarquesID, editar) {
    setAVisible(false);
    setCargando(true);
    let filter = {
      and: [
        {
          embarqueID: {
            eq: embarquesID,
          },
        },
        {
          activo: {
            eq: true,
          },
        },
      ],
    };
    //Se obtienen los datos del embarque
    //Se obtienen los datos del embarque
    var EmbarquesFromAPI = [];
    var Embarque = await GetEmbarquesID(embarquesID);
    if (Embarque.serialesEID) {
      var apiData = await ObtenerSerialesEmbarques(Embarque.serialesEID);
      //var apiData = await GetEmbarquesSeriales(filter);
      //Se ordenan los datos del embarque
      EmbarquesFromAPI = apiData.filter(embarques => (embarques.piezasEmbarcadas ? embarques.piezasEmbarcadas : 0) > 0).sort((a, b) =>
        a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0
      );
      await Promise.all(
        EmbarquesFromAPI.map(async (fembarque) => {
          const producto = await GetProductosID(fembarque.productoID);
          if (producto.precioUnitario || producto.precioUnitarioPC) {
            const precioUnit = producto.precioUnitario;
            fembarque.sinTotalScrapFactura = Embarque.sinTotalScrapFactura;
            fembarque.precioUnitario = editar === false ? precioUnit :
              fembarque.precioUnitario ? fembarque.precioUnitario : precioUnit;
            fembarque.Ecoat = editar === false ? producto.Ecoat :
              fembarque.Ecoat ? fembarque.Ecoat : producto.Ecoat;
            fembarque.Pcoat = editar === false ? producto.Pcoat :
              fembarque.Pcoat ? fembarque.Pcoat : producto.Pcoat;
            fembarque.precioUnitarioPC = editar === false ? producto.precioUnitarioPC :
              fembarque.precioUnitarioPC ? fembarque.precioUnitarioPC : producto.precioUnitarioPC;

            fembarque.precioUnitarioTot = editar === false ? parseFloat(fembarque.precioUnitario ? fembarque.precioUnitario : 0) +
              parseFloat(fembarque.precioUnitarioPC ? fembarque.precioUnitarioPC : 0) :
              fembarque.precioUnitarioTot ? fembarque.precioUnitarioTot : 0;


            const totalP = ((fembarque.precioUnitarioTot *
              ((fembarque.piezasPintadas ? fembarque.piezasPintadas : 0) +
                (fembarque.piezasPintadasExtra ? fembarque.piezasPintadasExtra : 0) +
                (Embarque.sinTotalScrapFactura ? 0 : (fembarque.piezasNRecuperadas ? fembarque.piezasNRecuperadas : 0)))).toFixed(2));
            const descuento = Embarque.facturaDescuentoP ? ((totalP * Embarque.facturaDescuentoP) / 100).toFixed(2) : 0;
            const divisa = (producto.divisa === "Peso mexicano" ||
              producto.divisa === "Dólar" ? "$" : "€");
            fembarque.precioTotal = divisa + (totalP - descuento);
            fembarque.divisa = producto.divisa;
            fembarque.descuento = divisa + descuento;

            //Precios subtotal, descuento, con descuento y divisa
            fembarque.precioSubTotalSDV = (totalP);
            fembarque.precioTotalDesSDV = (descuento);
            fembarque.precioTotalSDV = (totalP - descuento);
            fembarque.divisaPS = (divisa);
          }
          if (!fembarque.clienteEntregaID) {
            fembarque.clienteEntregaID = embarques.clienteID;
            fembarque.clienteEntrega = embarques.cliente;
          }
          if ((fembarque.descripcion ? fembarque.descripcion : "") === "") {
            fembarque.descripcion = producto.descripcion;
          }
          return fembarque;
        })
      );
    }

    setAVisible(false);
    setCargando(false);
    return EmbarquesFromAPI;
  }
  async function clicMostrar(embarque) {
    setAVisible(false);
    setCargando(false);
    const listas = !embarque.servicioExtraEmbarques ? embarque.seriales ? await fetchEmbarqueSerial(embarque.id, false) : [] : [];
    const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
      await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
    setServicios(listaServicios.servicios ? true : false);
    setInputList(listaServicios.servicios ? listaServicios.servicios : listas);
    setClienteID(embarque.clienteID);
    setRCliente(embarque.cliente);
    setClienteEntregaID(embarque.clienteEntregaID);
    setRClienteEntrega(embarque.clienteEntrega);
    setRClienteFacturarA(
      embarque.facturarA ? embarque.facturarA : embarque.clienteEntrega
    );
    setInvoiceID("BTI-" + aLetra + embarque.numero);
    setFechaFactura(embarque.fechaFactura);
    setRequisitioner(embarque.requisitioner);
    setPoNumber(embarque.poNumber);
    setNumeroP(embarque.numero);
    setEditar(false);
    setTituloTab("Detalle de invoice");
    setTituloTab("Detalle de embarque");
    toggle1("3");
  }
  // handle change event
  function handlePageChangeFactura(pageNumber) {
    setAVisible(false);
    setCargando(false);
    setCurrentPage(pageNumber);
    busqueFactura(
      facturasSinFiltro,
      searchBy,
      search,
      pageNumber,
      fechaPBusqueda
    );
  }
  function handlePageChangeEmbarques(pageNumber) {
    setAVisible(false);
    setCargando(false);
    setCurrentPageEmbarques(pageNumber);
    busquedaEmbarques(
      embarquesSinFiltro,
      searchByEmbarque,
      searchEmbarque,
      pageNumber,
      fechaPBusqueda
    );
  }
  function clicNuevaInvoice() {
    setInputList([]);
    setHabilitarBRE(true);
    setInputListServicios([]);
    setEmbarqueEditando([]);
    setPoNumber("");
    setFechaFactura("");
    setRequisitioner("");
    setSalesPerson("");
    setComentariosFacturacion("");
    setFacturaDescuentoP("");
    setDueDate("");
    setInvoiceID("");
    setShipTo("");
    setBillTo("");
    setRCliente("");
    setClienteEntregaID("");
    setInvoiceID("");
    setRClienteEntrega("");
    setEditar(false);
    setTituloTab("Generar invoice");
    toggle1('3');
  };
  async function clicAgregar(embarque, i) {

    setAVisible(false);
    setCargando(false);
    setHabilitarBRE(false);
    const listas = !embarque.servicioExtraEmbarques ? embarque.seriales ? await fetchEmbarqueSerial(embarque.id, false) : [] : [];
    const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
      await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
    setServicios(listaServicios.servicios ? true : false);
    setInputList(listaServicios.servicios ? listaServicios.servicios : listas);
    embarquesSinFiltro[i].facturado = true;
    setInvoiceID("BTI-" + aLetra + embarque.numero);
    setEmbarqueEditando(embarque);
    setRCliente(embarque.cliente);
    setClienteEntregaID(embarque.clienteEntregaID);
    setRClienteEntrega(embarque.clienteEntrega);
    setPoNumber(embarque.ordenDeCompra);
    setFacturaDescuentoP("");
    const clienteF = await GetClientesID(embarque.clienteEntregaID);
    if (clienteF.id) {
      setBillTo(clienteF.billTo);
      setShipTo(clienteF.shipTo);
    }
    toggle1("3");
  };
  async function clicEditar(embarque, i) {

    setAVisible(false);
    setCargando(false);
    setEditar(true);
    setInvoiceID(embarque.invoiceID);
    const listas = !embarque.servicioExtraEmbarques ? embarque.seriales ? await fetchEmbarqueSerial(embarque.id, true) : [] : [];
    const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
      await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
    setServicios(listaServicios.servicios ? true : false);
    setInputList(listaServicios.servicios ? listaServicios.servicios : listas);
    const servicios = (embarque.serviciosExtra ? embarque.serviciosExtra : []).length > 0 ? await ObtenerServiciosFacturacion(embarque.serviciosExtra) : [];
    setInputListServicios(servicios.servicios ? servicios.servicios : []);
    setInvoiceID("BTI-" + aLetra + embarque.numero);
    //embarquesSinFiltro[i].facturado = true;
    setEmbarqueEditando(embarque);
    setFechaFactura(embarque.fechaDeFacturacion);
    setRequisitioner(embarque.requisitioner);
    setSalesPerson(embarque.salesPerson);
    setComentariosFacturacion(embarque.comentariosFacturacion);
    setFacturaDescuentoP(embarque.facturaDescuentoP);
    setDueDate(embarque.dueDate);
    setShipTo(embarque.shipTo);
    setBillTo(embarque.billTo);
    setRCliente(embarque.cliente);
    setClienteEntregaID(embarque.clienteEntregaID);
    setRClienteEntrega(embarque.clienteEntrega);
    setPoNumber(embarque.ordenDeCompra);
    setTituloTab("Editar invoice");
    const clienteF = await GetClientesID(embarque.clienteEntregaID);
    if (clienteF.id) {
      setBillTo(clienteF.billTo);
      setShipTo(clienteF.shipTo);
    }
    toggle1("3");
  };
  async function clicImprimir(embarque) {
    setAVisible(false);
    setCargando(false);
    const listas = !embarque.servicioExtraEmbarques ? embarque.seriales ? await fetchEmbarqueSerial(embarque.id, true) : [] : [];
    const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
      await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
    setServicios(listaServicios.servicios ? true : false);
    setInputList(listaServicios.servicios ? listaServicios.servicios : listas);
    const servicios = (embarque.serviciosExtra ? embarque.serviciosExtra : []).length > 0 ? await ObtenerServiciosFacturacion(embarque.serviciosExtra) : [];
    setInputListServicios(servicios.servicios ? servicios.servicios : []);
    setSumTotalServicio(servicios.total);
    //setEmbarqueEditando(embarque);
    setFechaFactura(embarque.fechaDeFacturacion);
    setRequisitioner(embarque.requisitioner);
    setPoNumber(embarque.PO);
    setSalesPerson(embarque.salesPerson);
    setComentariosFacturacion(embarque.comentariosFacturacion);
    setFacturaDescuentoP(embarque.facturaDescuentoP);
    setDueDate(embarque.dueDate);
    setCasQuote(embarque.casQuote);
    setInvoiceID(embarque.invoiceID);
    setAMRecuperado(
      embarque.piezasNRecuperadas
        ? embarque.piezasNRecuperadas > 0
          ? true
          : false
        : false
    );
    var totalCaja = 0;
    var totalContenedores = 0;
    var totalTarima = 0;
    //Orden por número de parte
    const listapNP = listas.sort((a, b) =>
      a.numerodeParte > b.numerodeParte
        ? 1
        : a.numerodeParte < b.numerodeParte
          ? -1
          : 0
    );
    //Total por número de parte
    var totNParte = [];
    var numeroParte = "";
    var totNPPiezas = 0;
    var subTotNP = 0;
    var desTotNP = 0;
    var totNP = 0;
    var totCNP = 1;
    var totalD = 0;
    var subTotalD = 0;
    var desTotalD = 0;
    var divisaD = "";
    var divisa = "";
    var pos = "";
    await Promise.all(
      listapNP.map(async (embarquesd, j) => {
        pos = pos === "" ? embarquesd.po : pos + ", " + embarquesd.po;
        totalD = totalD + parseFloat(embarquesd.precioTotalSDV);
        subTotalD = subTotalD + parseFloat(embarquesd.precioSubTotalSDV);
        desTotalD = desTotalD + parseFloat(embarquesd.precioTotalDesSDV);
        divisaD = embarquesd.divisaPS;
        divisa = embarquesd.divisa;
        if (listapNP.length > j + 1) {
          if (numeroParte === embarquesd.numerodeParte) {
            totNPPiezas += embarque.sinTotalScrapFactura === true ? embarquesd.piezasPintadas + (embarquesd.piezasPintadasExtra ? embarquesd.piezasPintadasExtra : 0) : embarquesd.piezasEmbarcadas;
            subTotNP += parseFloat(embarquesd.precioSubTotalSDV);
            desTotNP += parseFloat(embarquesd.precioTotalDesSDV);
            totNP += parseFloat(embarquesd.precioTotalSDV);
            totCNP++;
            if (numeroParte != listapNP[j + 1].numerodeParte) {
              totNParte.push({ ...embarquesd, totalNumeroParte: totNPPiezas, totalCantidad: totCNP, subTotNP: divisaD + (subTotNP ? subTotNP.toFixed(2) : subTotNP), desTotNP: divisaD + (desTotNP ? desTotNP.toFixed(2) : desTotNP), totNP: divisaD + (totNP ? totNP.toFixed(2) : totNP) })
            }
          } else {
            numeroParte = embarquesd.numerodeParte;
            totNPPiezas = embarque.sinTotalScrapFactura === true ? embarquesd.piezasPintadas + (embarquesd.piezasPintadasExtra ? embarquesd.piezasPintadasExtra : 0) : embarquesd.piezasEmbarcadas;
            subTotNP = parseFloat(embarquesd.precioSubTotalSDV);
            desTotNP = parseFloat(embarquesd.precioTotalDesSDV);
            totNP = parseFloat(embarquesd.precioTotalSDV);
            totCNP = 1;
            if (numeroParte != listapNP[j + 1].numerodeParte) {
              totNParte.push({ ...embarquesd, totalNumeroParte: totNPPiezas, totalCantidad: totCNP, subTotNP: divisaD + (subTotNP ? subTotNP.toFixed(2) : subTotNP), desTotNP: divisaD + (desTotNP ? desTotNP.toFixed(2) : desTotNP), totNP: divisaD + (totNP ? totNP.toFixed(2) : totNP) })
            }
          }
        } else {
          if (numeroParte === embarquesd.numerodeParte) {
            totNPPiezas += embarque.sinTotalScrapFactura === true ? embarquesd.piezasPintadas + (embarquesd.piezasPintadasExtra ? embarquesd.piezasPintadasExtra : 0) : embarquesd.piezasEmbarcadas;
            subTotNP += parseFloat(embarquesd.precioSubTotalSDV);
            desTotNP += parseFloat(embarquesd.precioTotalDesSDV);
            totNP += parseFloat(embarquesd.precioTotalSDV);
            totCNP++;
            totNParte.push({ ...embarquesd, totalNumeroParte: totNPPiezas, totalCantidad: totCNP, subTotNP: divisaD + (subTotNP ? subTotNP.toFixed(2) : subTotNP), desTotNP: divisaD + (desTotNP ? desTotNP.toFixed(2) : desTotNP), totNP: divisaD + (totNP ? totNP.toFixed(2) : totNP) })
          } else {
            numeroParte = embarquesd.numerodeParte;
            totNPPiezas = embarque.sinTotalScrapFactura === true ? embarquesd.piezasPintadas + (embarquesd.piezasPintadasExtra ? embarquesd.piezasPintadasExtra : 0) : embarquesd.piezasEmbarcadas;
            subTotNP = parseFloat(embarquesd.precioSubTotalSDV);
            desTotNP = parseFloat(embarquesd.precioTotalDesSDV);
            totNP = parseFloat(embarquesd.precioTotalSDV);
            totCNP = 1;
            totNParte.push({ ...embarquesd, totalNumeroParte: totNPPiezas, totalCantidad: totCNP, subTotNP: divisaD + (subTotNP ? subTotNP.toFixed(2) : subTotNP), desTotNP: divisaD + (desTotNP ? desTotNP.toFixed(2) : desTotNP), totNP: divisaD + (totNP ? totNP.toFixed(2) : totNP) })

          }
        }
        //Se obtiene el total de cajas y contenedores
        if (embarquesd.materialEn === "Caja") {
          totalCaja = parseFloat(totalCaja) + parseFloat(embarquesd.materialEnCantidad);
        }
        if (embarquesd.materialEn === "Contenedor") {
          totalContenedores = parseFloat(totalContenedores) + parseFloat(embarquesd.materialEnCantidad);
        }
        if (embarquesd.materialEn === "Tarima") {
          totalTarima = parseFloat(totalTarima) + parseFloat(embarquesd.materialEnCantidad);
        }
        return embarquesd;
      })
    );
    //}

    setSumCajas(listaServicios.servicios ? listaServicios.totalCaja : totalCaja);
    setSumTarimas(listaServicios.servicios ? listaServicios.totalTarima : totalTarima);
    setSumContenedores(listaServicios.servicios ? listaServicios.totalContenedores : totalContenedores);
    setPosS(pos);

    setSinTotalScraptFactura(embarque.sinTotalScrapFactura ? embarque.sinTotalScrapFactura : false);
    setSumTotal(listaServicios.servicios ? ("$" + listaServicios.totalD.toFixed(2)) : (divisa === "Peso mexicano" ||
      divisa === "Dólar" ? "$" : "€") + totalD.toFixed(2));
    setSumTotalDes(listaServicios.servicios ? "$" + (listaServicios.desTotalD ? listaServicios.desTotalD.toFixed(2) : "0") : (divisaD + (desTotalD ? desTotalD.toFixed(2) : "0")));
    setSubSumTotal(listaServicios.servicios ? "$" + (listaServicios.subTotalD ? listaServicios.subTotalD.toFixed(2) : listaServicios.totalD.toFixed(2)) : (divisaD + (subTotalD ? subTotalD.toFixed(2) : totalD.toFixed(2))));
    setRCliente(embarque.cliente);
    setTotalNumeroParte(totNParte);
    setClienteEntregaID(embarque.clienteEntregaID);
    setRClienteEntrega(embarque.clienteEntrega);
    const clienteF = await GetClientesID(embarque.clienteEntregaID);
    if (clienteF.id) {
      setBillTo(clienteF.billTo);
      setShipTo(clienteF.shipTo);
    }
    handlePrint();
  };
  //Revisa cambios en el input de clientes
  function onChangesDatosFactura(e) {

    if (e.target.name === "fechaFactura") {
      setFechaFactura(e.target.value);
    }
    if (e.target.name === "requisitioner") {
      setRequisitioner(e.target.value)
    }
    if (e.target.name === "poNumber") {
      setPoNumber(e.target.value)
    }
    if (e.target.name === "salesPerson") {
      setSalesPerson(e.target.value)
    }
    if (e.target.name === "comentariosFacturacion") {
      setComentariosFacturacion(e.target.value)
    }
    if (e.target.name === "dueDate") {
      setDueDate(e.target.value)
    }

    // cambioDatosEmbarque(e);
  }

  function cancelarFactura() {
    //fetchFacturas(rfechaini, rfechafin);  

    setInputList([]);
    setInputListServicios([]);
    setEmbarqueEditando([]);
    setInvoiceID("");
    setEditar(false);
    setShipTo("");
    setBillTo("");
    setClienteEntregaID("");
    setRClienteEntrega("");
    setFechaFactura("");
    setRequisitioner("");
    setSalesPerson("");
    setComentariosFacturacion("");
    setFacturaDescuentoP("");
    setDueDate("");
    setTituloTab("Generar invoice");
    setHabilitarBRE(true);
    toggle1("1");
    fetchFacturas(rfechaini, rfechafin);
    fetchEmbarques();
  }
  // handle input change
  function handleInputChange(e, index, list) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      list[index][name] = value;
    }
    const totalP = ((list[index].precioUnitarioTot *
      ((list[index].piezasPintadas ? list[index].piezasPintadas : 0) +
        (list[index].piezasPintadasExtra ? list[index].piezasPintadasExtra : 0) +
        (list[index].sinTotalScrapFactura ? 0 : list[index].piezasNRecuperadas ? list[index].piezasNRecuperadas : 0))).toFixed(2));
    const descuento = facturaDescuentoP ? ((totalP * facturaDescuentoP) / 100) : 0;
    const divisa = (list[index].divisa === "Peso mexicano" ||
      list[index].divisa === "Dólar" ? "$" : "€");
    list[index].precioTotal = value != "." ? divisa + ((totalP - descuento) ? (totalP - descuento).toFixed(2) : (totalP - descuento)) : 0;
    list[index].descuento = divisa + (descuento ? descuento.toFixed(2) : descuento);
    list[index].precioSubTotalSDV = (totalP ? totalP : 0);
    list[index].divisaPS = divisa;





    return list;
  }

  // handle input change
  function handleInputChangePD(e, list) {
    const re = /^[0-9\.]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setFacturaDescuentoP(e.target.value);
      list.map((embarques, i) => {
        if (
          (embarques.precioUnitarioTot)) {
          const totalP = ((embarques.precioUnitarioTot *
            ((embarques.piezasPintadas ? embarques.piezasPintadas : 0) +
              (embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0) +
              (embarques.sinTotalScrapFactura ? 0 : embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0))).toFixed(2));
          const descuento = e.target.value ? ((totalP * e.target.value) / 100) : 0;
          const divisa = (embarques.divisa === "Peso mexicano" ||
            embarques.divisa === "Dólar" ? "$" : "€");
          embarques.precioTotal = divisa + (totalP - descuento) ? (totalP - descuento).toFixed(2) : (totalP - descuento);
          embarques.descuento = divisa + (descuento ? descuento.toFixed(2) : descuento);
          embarques.precioSubTotalSDV = totalP ? totalP : totalP;
          embarques.divisaPS = divisa;
        }
      });
    }
    return list;
  }


  function handleInputChangeServicios(e, index, list) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (name === "description") {
      list[index][name] = value;
    } else {
      if (e.target.value === '' || re.test(e.target.value)) {
        list[index][name] = value;
      }
      list[index].total = ((list[index].uprice * list[index].quantity)).toFixed(2);
    }
    return list;
  }
  function revisarDatosCompletos(list) {
    var datosCompletos = true;
    list.map((embarques, i) => {
      if (
        (!embarques.precioUnitarioTot)) {
        datosCompletos = false;
      }
    });
    return datosCompletos;
  }

  function revisarDatosCompletosServicios(list) {
    var datosCompletos = true;
    list.map((servicios) => {
      if (
        (!servicios.quantity || !servicios.description || !servicios.uprice || !servicios.total)) {
        datosCompletos = false;
      }
    });
    return datosCompletos;
  }

  // handle click event of the Add button
  function handleAddClick(list, datos) {
    list.push(datos)
    return list;
  }

  // handle click event of the Remove button
  function handleRemoveClick(index, list) {
    list.splice(index, 1);
    //list[index].activo = false;
    return list;
  }

  async function manageFacturacion() {
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    try {
      setMensajeAlert("Revisando cambios");
      //const ILCambios = inputList.filter(embarques => embarques.modificado === true);
      //setMensajeAlert("Cambios revisados" + JSON.stringify(ILCambios));
      //if (ILCambios[0]) {
      setMensajeAlert("Sí hay cambios");
      const datosCompletos = await revisarDatosCompletos(inputList);
      const datosCompletosServicios = await revisarDatosCompletosServicios(inputListServicios);
      setMensajeAlert("Datos revisados");
      var mensaje = "";
      if (!fechaFactura || !requisitioner || !poNumber || !salesPerson || !dueDate
        || !shipTo || !billTo || !clienteEntregaID || datosCompletos === false || datosCompletosServicios === false) {
        mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios.";/*" Datos completos: " + datosCompletos +
          "Datos seviciosCompletos:" + datosCompletosServicios + " Fecha: " + fechaFactura + " requi: " + requisitioner +
          " po: " + poNumber + " salesp: " + salesPerson + " dueD: " + dueDate + " ship: " + shipTo + " bill: " + billTo +
          " cliente: " + clienteEntregaID; // + datosCompletos;*/
        setDatosIncompletos(true);
        setMensajeAlert(mensaje);
      }
      /*if (cantidadValida === false) {
        mensaje =
          mensaje +
          "\n Datos no válidos; la suma de las cantidades a embarcar, no debe ser mayor a la cantidad disponible," +
          " la cantidad no puede ser cero, se marca en rojo la cantidad errónea";
        setMensajeAlert(mensaje);
      }*/
      setMensajeAlert("Revisando mensajes");
      if (mensaje !== "") {
        setMensajeAlert(mensaje);
        setColor("warning");
        setAVisible(true);
        setisDisabled(false);
        setCargando(false);
        window.scrollTo(0, 0);
        return
      } else {
        setMensajeAlert("Sin mensaje");
        var pConcurrencia = false;
        var EmbarquesC = {};
        setMensajeAlert("Antes de editar");
        const embarqueid = embarqueEditando.id;
        if (embarqueid) {
          setMensajeAlert("Editando");
          //Se obtienen los datos del embarque por id para revisa la concurrencia
          EmbarquesC = await GetEmbarquesID(embarqueid);
          setMensajeAlert("Datos de embarque; " + JSON.stringify(EmbarquesC));
          if (!EmbarquesC.id) {
            pConcurrencia = true;
          } else {
            if (EmbarquesC.updatedAt !== embarqueEditando.updatedAt) {
              pConcurrencia = true;
              mensaje = "Operación denegada; concurrencia en los datos generales del embarque.";
            }
          }
          if (servicios === false) {
            await Promise.all(
              inputList.map(async (embarques) => {
                if (embarques.id) {
                  setMensajeAlert(
                    "Error al obtener los embarques por serial para revisar la concurrencia"
                  );
                  //Se obtienen los datos de embarques seriales por id
                  const EmbarquesS = await GetEmbarquesSerialesID(embarques.id);
                  setMensajeAlert(
                    "Embarques obtenidos" + JSON.stringify(EmbarquesS)
                  );
                  if (!EmbarquesS.id) {
                    pConcurrencia = true;
                    setMensajeAlert("Concurrencia 1");
                  } else {
                    if (embarques.updatedAt !== EmbarquesS.updatedAt) {
                      pConcurrencia = true;
                      setMensajeAlert("Concurrencia 2");
                    }
                  }
                  setMensajeAlert("Sin concurrencia " + JSON.stringify(EmbarquesS));
                  //embarqueid = EmbarquesS.embarqueID;
                  setMensajeAlert("Sin concurrencia 1");
                }

              }));
          }
        } else {
          mensaje = "Operación denegada; no se encontraron datos del embarque relacionado, favor de comunicarse a sistemas";
          setMensajeAlert(mensaje);
        }
        setMensajeAlert("Sin mensaje 2; " + mensaje);
        //Se revisa si hay mensaje de error, si es así, se termina la transacción.
        if (mensaje !== "") {
          setMensajeAlert(mensaje);
          setColor("warning");
          setAVisible(true);
          setisDisabled(false);
          setCargando(false);
          window.scrollTo(0, 0);
          return;
        }
        if (pConcurrencia === false) {
          //Se empieza a realizar el registro de facturación
          if (servicios === false) {
            await Promise.all(
              inputList.map(async (embarques) => {
                //Se obtiene el registro actualizado de los reciba seriales por id
                await setMensajeAlert("Antes de obtener el reciba serial por ID:");
                const recibam = await GetRecibaSerialesID(embarques.recibaSerialID);
                setMensajeAlert("Se obtuvieron los datos del serial correspondiente ");
                if (recibam.id) {
                  //Se registran las piezas facturadas y el id de embarquesSerial en recibaSeriales
                  if (!editar) {
                    recibam.piezasFacturadas = recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0;
                  }
                  setMensajeAlert("Trabajando con reciba 0:" + JSON.stringify(recibam));
                  recibam.facturacionSEID = await combinarIDS((recibam.facturacionSEID ? recibam.facturacionSEID : []),
                    ([{ id: embarques.id, nuevo: true, activo: true }]));
                  setMensajeAlert("Trabajando con reciba 1:" + JSON.stringify(recibam));
                  recibam.Reg_Mod_Usuario = userName;
                  delete recibam.updatedAt;
                  delete recibam.__typename;
                  delete recibam.createdAt;
                  delete recibam.piezasCtnaRecuperadas;
                  delete recibam.piezasInspeccion;
                  delete recibam.piezasInspeccionPC;
                  delete recibam.piezasIRecuperacion;
                  delete recibam.piezasCRecuperacion;
                  delete recibam.PiezasCtnaRecuperacion;
                  delete recibam.piezasTRecuperacion;
                  delete recibam.piezasRecuperadas;
                  if (!delete recibam.piezasCtnaNRecuperadas) { delete recibam.piezasCtnaNRecuperadas; };

                  //Piezas no pintadas para devolución.
                  //Piezas  de cuarentena no pintadas, embarcadas para su devolución. piezasCtnaEmbarcadas
                  /*------------------------------------------------------------------------------------------------------------*/
                  //Se actualizan los datos en reciba Seriales                                                  
                  setMensajeAlert("Error al actualizar reciba seriales " + JSON.stringify(recibam));
                  await API.graphql({
                    query: updateRecibaSeriales,
                    variables: { input: recibam },
                  });

                }
                //Se actualizan los datos en embarques seriales
                setMensajeAlert("Trabajando con embarque 0:");

                embarques.facturado = true;
                embarques.invoiceID = "BTI-" + aLetra + embarques.numero;
                embarques.Reg_Mod_Usuario = userName;
                setMensajeAlert("Trabajando con embarque 1:");
                delete embarques.createdAt;
                delete embarques.updatedAt;
                delete embarques.__typename;
                delete embarques.modificado;
                delete embarques.precioTotalSDV;
                delete embarques.precioSubTotalSDV;
                delete embarques.precioTotalDesSDV;
                delete embarques.divisaPS;
                delete embarques.precioTotal;
                delete embarques.descuento;
                delete embarques.sinTotalScrapFactura;

                setMensajeAlert(
                  "Error al intentar guardar los cambios en embarqueseriales: " +
                  JSON.stringify(embarques)
                );
                await API.graphql({
                  query: updateEmbarqueSeriales,
                  variables: { input: embarques },
                });

              }));
          }
          //Se actualizan los datosde embarques       
          setMensajeAlert("Error al intentar obtener datos del embarque para editar");

          var formData = await GetEmbarquesID(embarqueid);
          formData.facturado = true;
          formData.fechaDeFacturacion = fechaFactura;
          formData.billTo = billTo;
          formData.shipTo = shipTo
          formData.salesPerson = salesPerson;
          formData.PO = poNumber;
          formData.serviciosExtra = inputListServicios;
          if (servicios === true) {
            formData.servicioExtraEmbarques = inputList;
          } else {
            if (formData.servicioExtraEmbarques) {
              formData.servicioExtraEmbarques = [];
            }
          }
          formData.requisitioner = requisitioner
          formData.comentariosFacturacion = comentariosFacturacion;
          formData.facturaDescuentoP = facturaDescuentoP;
          formData.casQuote = "BTIMF111319-001A";
          //formData.shippedvia = 
          formData.dueDate = dueDate;
          formData.invoiceID = "BTI-" + aLetra + formData.numero;

          delete formData.createdAt;
          delete formData.updatedAt;
          delete formData.__typename;
          if (formData.facturaDescuentoP === "") {
            delete formData.facturaDescuentoP;
          }
          setMensajeAlert(
            "Error al intentar guardar los datos del embarque " + JSON.stringify(formData)
          );
          await API.graphql({
            query: updateEmbarque,
            variables: { input: formData },
          });


          setMensajeAlert("Operación exitosa ");
          setisDisabled(false);
          setColor("primary");
          setAVisible(true);
          setCargando(true);
          fetchFacturas(rfechaini, rfechafin);
          setInputList([]);
          setHabilitarBRE(true);
          setInputListServicios([]);
          setEmbarqueEditando([]);
          toggle1("1");
          setFechaFactura("");
          setRequisitioner("");
          setPoNumber("");
          setSalesPerson("");
          setComentariosFacturacion("");
          setFacturaDescuentoP("");
          setDueDate("");
          setInvoiceID("");
          setShipTo("");
          setBillTo("");
          setClienteEntregaID("");
          setRClienteEntrega("");
          setCargando(false);
        } else {
          //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
          window.scrollTo(0, 0);
          setMensajeAlert(
            "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
            " volver a intentarlo"
          );
          setColor("warning");
          setCargando(false);
          setAVisible(true);
          setisDisabled(false);
          fetchFacturas(rfechaini, rfechafin);
        }
      }
      /*} else {
        setMensajeAlert("Sin cambios que actualizar");
        setisDisabled(false);
        setColor("primary");
        setAVisible(true);
        setCargando(true);
        fetchFacturas(rfechaini, rfechafin);
        setInputList([]);
        setHabilitarBRE(true);
        setInputListServicios([]);
        
        toggle1("1");
        setFechaFactura("");
        setRequisitioner("");
        setPoNumber("");
        setSalesPerson("");
        setComentariosFacturacion("");
        setDueDate("");
        setShipTo("");
        setBillTo("");
        setClienteEntregaID("");
        setRClienteEntrega("");
        setCargando(false);
      }*/
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert("Error:" + JSON.stringify(e));
      //"No fue posible terminar la operación: revise si la operación se realizó parcialmente, revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas"
      setColor("warning");
      setAVisible(true);
      /*fetchFacturas(rfechaini, rfechafin);
      setInputList([]);
      setHabilitarBRE(true);
      setInputListServicios([]);
      setEmbarqueEditando([]);
      toggle1("1");
      setFechaFactura("");
      setRequisitioner("");
      setPoNumber("");
      setSalesPerson("");
      setComentariosFacturacion("");
      setDueDate("");
      setShipTo("");
      setBillTo("");
      setClienteEntregaID("");
      setRClienteEntrega("");*/
      setCargando(false);
      setisDisabled(false);
    }
  }

  return (
    <>
      <Navbarh />
      {pfacturacion === true && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoMdCard
                className="iconoc floatleft"
                onClick={() => {
                  toggle1("1");
                }}
              />
              <h3>{formType}</h3>
            </div>
          </Row>
          <div className="conteiner2">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              </Row>
            )}

            <Fragment>
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle1("1");
                      }}
                    >
                      Invoices
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle1("2");
                      }}
                    >
                      Pendientes de facturar
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => {
                        toggle1("3");
                      }}
                    >
                      {tituloTab}
                    </NavLink>
                  </NavItem>
                  <NavItem >
                    {/*style={{ display: "none" }} */}
                    <NavLink style={{ display: "none" }}
                      className={classnames({ active: activeTab === "4" })}
                      onClick={() => {
                        toggle1("4");
                      }}
                    >
                      Imprimir
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "5" })}
                      onClick={() => {
                        toggle1("5");
                      }}
                    >
                      Conceptos Generales
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      {pfacturacion && (
                        <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12 text-left">
                          <button
                            class="cbutton btn-success margintop20px ml-3"
                            onClick={() => {
                              clicNuevaInvoice();
                            }}
                          >
                            <span class="fa fa-plus">
                              Generar invoice
                            </span>
                          </button>
                        </div>
                      )}
                      <div class="col-lg-2 col-xs-12 text-left ">
                        <FormGroup>
                          <Label>
                            <h5>Busqueda por: </h5>
                          </Label>
                          <select name="recibabusqueda" onChange={buscarpor}>
                            <option value="cliente">Cliente</option>
                            <option value="paking">Packing/Line</option>
                            <option value="numero de parte">
                              Número de parte
                            </option>
                            <option value="lote">Lote</option>
                            <option value="fecha">Fecha de embarque</option>
                            <option value="serial">Serial</option>
                            <option value="invoiceid">Invoice ID</option>
                          </select>
                          <Input
                            type={searchBy !== "fecha" ? "text" : "date"}
                            placeholder={"Búsqueda por " + searchBy}
                            onChange={
                              searchBy !== "fecha"
                                ? (e) => setSearch(e.target.value)
                                : onSearchFecha
                            }
                            onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                            value={search}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop10px">
                        <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightleft ml-1">
                          <div className="  col-lg-2 col-md-2 col-sm-12 col-xs-12  ml-3"></div>
                          <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Del:</InputGroupText>
                              </InputGroupAddon>
                              <Input
                                name="rFechaIni"
                                type="date"
                                value={Moment(rfechaini).format("YYYY-MM-DD")}
                                onChange={onChangesRFechaini}
                              />
                            </InputGroup>
                          </div>
                          <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                            <InputGroup className="floatrightleft ml-1">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Al:</InputGroupText>
                              </InputGroupAddon>
                              <Input
                                name="rFechaFin"
                                type="date"
                                value={Moment(rfechafin).format("YYYY-MM-DD")}
                                onChange={onChangesRFechaini}
                              />
                            </InputGroup>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <button
                      className="cbutton btn-dark floatright  mr-3 marginrightmobil3p "
                      title="Recargar página"
                      onClick={() => {
                        fetchFacturas(rfechaini, rfechafin);
                      }}
                    >
                      <IoIcons.IoMdRefresh /> Recargar{" "}
                    </button>
                    <div>
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                        <Table className="mb-2 scroll ">
                          <Thead class="thead-secondary">
                            <Tr>
                              <Th className="minwidth80px">Invoice ID</Th>
                              <Th className="minwidth200px">Cliente</Th>
                              <Th className="minwidth200px">
                                Números de parte
                              </Th>
                              <Th>Seriales</Th>
                              <Th>Lotes</Th>
                              <Th>Packings/Lines</Th>
                              <Th className="minwidth80px">MFG Fecha</Th>
                              <Th className="minwidth80px">Fecha</Th>
                              <Th className="minwidth60px">
                                Piezas embarcadas
                              </Th>
                              <Th className="">
                                Scrap
                              </Th>
                              <Th className="">
                                Sumar scrap en Facura
                              </Th>
                              <Th className="minwidth60px">% Discount</Th>
                              <Th className="minwidth80px">Acciones</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {facturados.map((embarques, i) => (
                              embarques.facturado && (
                                <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                                  <Td>{embarques.invoiceID}</Td>
                                  <Td>{embarques.cliente}</Td>
                                  <Td>{embarques.numerosdeParte}</Td>
                                  <Td>{embarques.seriales}</Td>
                                  <Td
                                    className={
                                      embarques.descripcion
                                        ? ""
                                        : "margintopmobil20px"
                                    }
                                  >
                                    {embarques.lotes}
                                  </Td>
                                  <Td>{embarques.packings}</Td>
                                  <Td>{embarques.MFGFecha}</Td>
                                  <Td>{embarques.fechaDeFacturacion}</Td>
                                  <Td>{embarques.piezasEmbarcadas}</Td>
                                  {<Td >{embarques.piezasNRecuperadas}</Td>}
                                  <Td>{embarques.sinTotalScrapFactura ? "No" : "Sí"}</Td>
                                  <Td>{embarques.facturaDescuentoP ? embarques.facturaDescuentoP + "%" : ""}</Td>
                                  <Td className={embarques.facturaDescuentoP ? "" : "margintopmobil20px"}>
                                    <button
                                      class="btn-info cbutton mt-1 ml-1"
                                      onClick={() => clicMostrar(embarques)}
                                      title="Detalles del embarque"
                                    >
                                      {" "}
                                      <IoIcons.IoIosListBox />{" "}
                                    </button>
                                    {pfacturacion && (
                                      <>
                                        <button
                                          class="btn-primary cbutton mt-1 ml-1"
                                          onClick={() => clicEditar(embarques, i)}
                                          title="Editar"
                                        >
                                          {" "}
                                          <IoIcons.IoIosCreate />{" "}
                                        </button>
                                        <button
                                          class="btn-warning cbutton mt-1 ml-1"
                                          title="Invoice"
                                          onMouseDown={() => setIndexImp(0)}
                                          onClick={() => clicImprimir(embarques)}
                                        >

                                          <IoIcons.IoIosPrint />{" "}
                                        </button>
                                        <button
                                          class="btn-dark cbutton mt-1 ml-1"
                                          title="Servicios extra"
                                          onMouseDown={() => setIndexImp(1)}
                                          onClick={() => clicImprimir(embarques)}
                                          hidden={embarques.serviciosExtra ? embarques.serviciosExtra.length > 0 ? false : true : true}
                                        >
                                          <IoIcons.IoIosPrint />
                                        </button>
                                        {/**<button class="btn-danger cbutton mt-1 ml-1" onClick={() => clicEliminar(embarques)} title="Eliminar"> <IoIcons.IoIosClose /> </button> */}
                                      </>
                                    )}
                                  </Td>
                                </Tr>
                              )))}
                          </Tbody>
                        </Table>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 "></div>
                    </div>
                    <Modal isOpen={modal} toggle={toggle}>
                      <ModalHeader toggle={toggle}>
                        Generar Invoice
                      </ModalHeader>
                      <ModalBody>

                      </ModalBody>
                      <ModalFooter>
                        <Button color="primary"
                        // onClick={aceptarEliminar}
                        >
                          Aceptar
                        </Button>{" "}
                        <Button color="danger" onClick={toggle}>
                          Cancelar
                        </Button>
                      </ModalFooter>
                    </Modal>
                    <div className="mt-3 mb-3">
                      Página {currentPage}, mostrando del{" "}
                      {recordPerPage * currentPage - recordPerPage + 1} al{" "}
                      {facturasSinFiltro.length < recordPerPage * currentPage
                        ? facturasSinFiltro.length
                        : recordPerPage * currentPage}{" "}
                      de {facturasSinFiltro.length} registros
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12  ">
                      <div class="floatcenter">
                        <ul class="pagination">
                          <li
                            class={
                              currentPage === 1
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to first page"
                              onClick={() => handlePageChangeFactura(1)}
                            >
                              «
                            </a>
                          </li>
                          <li
                            class={
                              currentPage === 1
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to previous page"
                              onClick={() =>
                                handlePageChangeFactura(
                                  currentPage - 1
                                )
                              }
                            >
                              ⟨
                            </a>
                          </li>
                          {paginas.map(
                            (pagina) =>
                              pagina.pagina <
                              currentPage + pageRange &&
                              pagina.pagina >=
                              (paginas.length - (pageRange - 1) <
                                currentPage + pageRange - pageRange
                                ? paginas.length - (pageRange - 1)
                                : currentPage +
                                pageRange -
                                pageRange) && (
                                <li
                                  class={
                                    currentPage === pagina.pagina
                                      ? "page-item active"
                                      : "page-item "
                                  }
                                >
                                  <a
                                    class="page-link "
                                    onClick={() =>
                                      handlePageChangeFactura(pagina.pagina)
                                    }
                                  >
                                    {pagina.pagina}
                                  </a>
                                </li>
                              )
                          )}
                          <li
                            class={
                              currentPage === ultimoNumeroP
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to next page"
                              onClick={() =>
                                handlePageChangeFactura(
                                  currentPage + 1
                                )
                              }
                            >
                              ⟩
                            </a>
                          </li>
                          <li
                            class={
                              currentPage === ultimoNumeroP
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to last page"
                              onClick={() =>
                                handlePageChangeFactura(ultimoNumeroP)
                              }
                            >
                              »
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(embarques)}</div>*/}
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(embarquesSinFiltro)}</div>*/}
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <div class="col-lg-2 col-xs-12 text-left ">
                        <FormGroup>
                          <Label>
                            <h5>Busqueda por: </h5>
                          </Label>
                          <select name="recibabusqueda" onChange={buscarporEmbarque}>
                            <option value="cliente">Cliente</option>
                            <option value="paking">Packing/Line</option>
                            <option value="numero de parte">
                              Número de parte
                            </option>
                            <option value="lote">Lote</option>
                            <option value="fecha">Fecha de embarque</option>
                            <option value="serial">Serial</option>
                            <option value="id de embarque">ID de embarque</option>
                          </select>
                          <Input
                            type={searchByEmbarque !== "fecha" ? "text" : "date"}
                            placeholder={"Búsqueda por " + searchByEmbarque}
                            onChange={
                              searchByEmbarque !== "fecha"
                                ? (e) => setSearchEmbarque(e.target.value)
                                : onSearchFechaEmbarque
                            }
                            onKeyUp={searchByEmbarque !== "fecha" ? onSearchEmbarque : ""}
                            value={searchEmbarque}
                          />
                        </FormGroup>
                      </div>
                    </Row>
                    <Row>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <Label className="floatleft ml-3  mr-2">Packing generado hace:</Label>
                        <Label className="floatleft ml-2 bcolora">{"1 día"}</Label>
                        <Label className="floatleft ml-2 bcolorn">{"2 días"}</Label>
                        <Label className="floatleft ml-2 bcolorr">{"3 o más días"}</Label>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <button
                          className="cbutton btn-dark floatright  mr-3 marginrightmobil3p "
                          title="Recargar página"
                          disabled={!habilitarBRE}
                          onClick={() => {
                            fetchEmbarques();
                          }}
                        >
                          <IoIcons.IoMdRefresh /> Recargar{" "}
                        </button>
                      </div>
                    </Row>
                    <div>
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                        <Table className="mb-2 scroll ">
                          <Thead class="thead-secondary">
                            <Tr>
                              <Th>Packing ID</Th>
                              <Th className="minwidth200px">Cliente</Th>
                              <Th className="minwidth200px">
                                Números de parte
                              </Th>
                              <Th>Seriales</Th>
                              <Th>Lotes</Th>
                              <Th>Packings/Lines</Th>
                              <Th className="minwidth80px">MFG Fecha</Th>
                              <Th className="minwidth80px">Fecha</Th>
                              <Th className="minwidth60px">
                                Piezas embarcadas
                              </Th>
                              <Th className="">
                                Scrap
                              </Th>
                              <Th className="">
                                Sumar scrap en Facura
                              </Th>
                              {/*<Th className="minwidth60px">Piezas recuperadas</Th>*/}
                              <Th className="minwidth80px">Acciones</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {embarques.map((embarques, i) => (
                              !embarques.facturado && (
                                <Tr className={Moment(embarques.fechaDeEmbarque).format("YYYY-MM-DD") >=
                                  Moment(new Date()).format("YYYY-MM-DD") ? i % 2 !== 0 ? "table-active" : "" :
                                  embarques.DiasEmbarques === 1 ? "bcolora" : embarques.DiasEmbarques === 2 ? "bcolorn" : "bcolorr"}>
                                  <Td>{embarques.numero}</Td>
                                  <Td>{embarques.cliente}</Td>
                                  <Td>{embarques.numerosdeParte}</Td>
                                  <Td>{embarques.seriales}</Td>
                                  <Td
                                    className={
                                      embarques.descripcion
                                        ? ""
                                        : "margintopmobil20px"
                                    }
                                  >
                                    {embarques.lotes}
                                  </Td>
                                  <Td>{embarques.packings}</Td>
                                  <Td>{embarques.MFGFecha}</Td>
                                  <Td>{embarques.fechaDeEmbarque}</Td>
                                  <Td>{embarques.piezasEmbarcadas}</Td>
                                  {<Td >{embarques.piezasNRecuperadas}</Td>}
                                  <Td>{embarques.sinTotalScrapFactura ? "No" : "Sí"}</Td>
                                  <Td>
                                    <button
                                      class="btn-success cbutton mt-1 ml-1"
                                      onClick={() => clicAgregar(embarques, i)}
                                      title="Agregar packing"
                                    >
                                      <IoIcons.IoMdAdd />
                                    </button>
                                  </Td>
                                </Tr>
                              )))}
                          </Tbody>
                        </Table>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 "></div>
                    </div>
                    <div className="mt-3 mb-3">
                      Página {currentPageEmbarques}, mostrando del{" "}
                      {recordPerPageEmbarque * currentPageEmbarques - recordPerPageEmbarque + 1} al{" "}
                      {embarquesSinFiltro.length < recordPerPageEmbarque * currentPageEmbarques
                        ? embarquesSinFiltro.length
                        : recordPerPageEmbarque * currentPageEmbarques}{" "}
                      de {embarquesSinFiltro.length} registros
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12  ">
                      <div class="floatcenter">
                        <ul class="pagination">
                          <li class={currentPageEmbarques === 1 ? "page-item disabled" : "page-item"}
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to first page"
                              onClick={() => handlePageChangeEmbarques(1)}
                            >
                              «
                            </a>
                          </li>
                          <li
                            class={
                              currentPageEmbarques === 1
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to previous page"
                              onClick={() =>
                                handlePageChangeEmbarques(
                                  currentPageEmbarques - 1
                                )
                              }
                            >
                              ⟨
                            </a>
                          </li>
                          {paginasEmbarques.map(
                            (pagina) =>
                              pagina.pagina <
                              currentPageEmbarques + pageRange &&
                              pagina.pagina >=
                              (paginas.length - (pageRange - 1) <
                                currentPageEmbarques + pageRange - pageRange
                                ? paginas.length - (pageRange - 1)
                                : currentPageEmbarques +
                                pageRange -
                                pageRange) && (
                                <li
                                  class={
                                    currentPageEmbarques === pagina.pagina
                                      ? "page-item active"
                                      : "page-item "
                                  }
                                >
                                  <a
                                    class="page-link "
                                    onClick={() =>
                                      handlePageChangeEmbarques(pagina.pagina)
                                    }
                                  >
                                    {pagina.pagina}
                                  </a>
                                </li>
                              )
                          )}
                          <li
                            class={
                              currentPageEmbarques === ultimoNumeroP
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to next page"
                              onClick={() =>
                                handlePageChangeEmbarques(
                                  currentPageEmbarques + 1
                                )
                              }
                            >
                              ⟩
                            </a>
                          </li>
                          <li
                            class={
                              currentPageEmbarques === ultimoNumeroP
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to last page"
                              onClick={() =>
                                handlePageChangeEmbarques(ultimoNumeroP)
                              }
                            >
                              »
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="3">
                    {tituloTab != "Detalle de embarque" && (
                      <>
                        <Row>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px " >
                            <h5 className={!invoiceID ? "floatleft displaynone" : "floatleft"}>INVOICE ID {invoiceID}</h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px " >
                            <button className={editar ? "cbutton btn-success floatright ml-2 mr-3 displaynone" : "cbutton btn-success floatright ml-2 mr-3"} color="success" size="sm" title="Agregar fila desde packings" onClick={() => { toggle1('2'); }}> <span className="fa fa-plus"> Desde Packings</span> </button>
                            <button className={(inputList.length > 0 && inputListServicios.length <= 0) ? " cbutton btn-success floatright " : " cbutton btn-success floatright displaynone"} color="success" size="sm" title="Agregar datos nuevos"
                              onClick={(e) =>
                                setInputListServicios(handleAddClick([...inputListServicios], { ...serviciosIniciales, createdAt: new Date() }))
                              }> <span className="fa fa-plus"> Servicios extra</span> </button>
                          </div>
                        </Row>
                        {inputList.length > 0 && (
                          <>
                            <Row>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12   margintop20px ">
                                <Label className={datosIncompletos === true && !fechaFactura ? "floatleft novalido" : "floatleft"}>
                                  Date* {/*clienteID*/}{" "}
                                </Label>
                                <Input
                                  name="fechaFactura"
                                  type="date"
                                  onChange={onChangesDatosFactura}
                                  value={fechaFactura}
                                />
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className="floatleft">
                                  Cliente*{/* rCliente*/}{" "}
                                </Label>
                                <select
                                  name="clienteEntregaID"
                                  className="floatleft custom-select"
                                  onChange={onChangesClientes}
                                  disabled={true}
                                >
                                  <option className="" value="">
                                    Elige un cliente{" "}
                                  </option>
                                  {clientes.map((cliente) => (
                                    <>
                                      {cliente.activo && (
                                        <option
                                          className=""
                                          value={cliente.id}
                                          selected={
                                            clienteEntregaID === cliente.id ? true : false
                                          }
                                        >
                                          {cliente.cliente}
                                        </option>
                                      )}
                                    </>
                                  ))}
                                </select>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className={datosIncompletos === true && !requisitioner ? "floatleft novalido" : "floatleft"}>
                                  REQUISITIONER*
                                </Label>
                                <Input
                                  name="requisitioner"
                                  onChange={onChangesDatosFactura}
                                  value={requisitioner}
                                />
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className="floatleft">
                                  SUPPLIER P.O. NUMBER*
                                </Label>
                                <Input
                                  name="poNumber"
                                  onChange={onChangesDatosFactura}
                                  value={poNumber}
                                  disabled={true}
                                />
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className={datosIncompletos === true && !salesPerson ? "floatleft novalido" : "floatleft"}>
                                  SALES PERSON*
                                </Label>
                                <Input
                                  name="salesPerson"
                                  onChange={onChangesDatosFactura}
                                  value={salesPerson}
                                />
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className={datosIncompletos === true && !dueDate ? "floatleft novalido" : "floatleft"}>
                                  DUE DATE*
                                </Label>
                                <Input
                                  name="dueDate"
                                  type="date"
                                  onChange={onChangesDatosFactura}
                                  value={dueDate}
                                />
                              </div>
                              <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className="floatleft">
                                  Comments or special instructions
                                </Label>
                                <Input
                                  name="comentariosFacturacion"
                                  type="textarea"
                                  onChange={onChangesDatosFactura}
                                  value={comentariosFacturacion}
                                  rows="1"
                                />
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                <Label className={"floatleft"}>
                                  % Discount
                                </Label>
                                <Input
                                  name="facturaDescuentoP"
                                  type="text"
                                  onChange={(e) =>
                                    setInputList(
                                      handleInputChangePD(e, [
                                        ...inputList,
                                      ])
                                    )
                                  }
                                  value={facturaDescuentoP}
                                />
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop20px ">
                                <Label className={datosIncompletos === true && !shipTo ? "floatleft novalido" : "floatleft"}>
                                  Ship To: {shipTo}
                                </Label>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop20px ">
                                <Label className={datosIncompletos === true && !billTo ? "floatleft novalido" : "floatleft"}>
                                  Bill To: {billTo}
                                </Label>
                              </div>
                            </Row>
                            <Row>
                              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                <Table className=" mb-2  ">
                                  <Thead class="thead-secondary">
                                    <Tr>
                                      <Th>Quantity</Th>
                                      <Th className="minwidth100px">Part Number</Th>
                                      <Th className="minwidth130px">Serial</Th>
                                      <Th className={rCliente === "Olson Internacional" ? "minwidth130px" : "displaynone minwidth130px"}>
                                        PO
                                      </Th>
                                      <Th className="minwidth130px">{rCliente === "Olson Internacional"
                                        ? "LINE"
                                        : "SHIPPER"}</Th>
                                      <Th className="minwidth130px">Pieces</Th>
                                      <Th className="width130px">
                                        Unit price*
                                      </Th>
                                      <Th className="minwidth130px">Sub-Total</Th>
                                      <Th className="minwidth130px">Discount</Th>
                                      <Th>Total* </Th>
                                      {/*<Th className="width30px"> Modificado </Th>
                                      <Th className="width30px"> Eliminar </Th>*/}
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {inputList.map(
                                      (x, i) =>
                                        (x.activo || servicios == true) && (
                                          <Tr
                                            className={
                                              i % 2 !== 0 ? "table-active" : ""
                                            }
                                          >
                                            <Td>{x.materialEnCantidad}</Td>
                                            <Td>{x.numerodeParte}</Td>
                                            <Td>{x.serialNRecuperado
                                              ? x.serialNRecuperado
                                              : x.serial}</Td>
                                            <Td className={rCliente === "Olson Internacional" ? " " : "displaynone"}>{x.po}</Td>
                                            <Td>{x.packing}</Td>
                                            <Td className="">{
                                              (x.piezasPintadas ? x.piezasPintadas : 0) +
                                              (x.piezasPintadasExtra ? x.piezasPintadasExtra : 0) +
                                              (x.sinTotalScrapFactura ? 0 : x.piezasNRecuperadas ? x.piezasNRecuperadas : 0)}
                                            </Td>
                                            <Td className={datosIncompletos === true && !x.precioUnitarioTot ? "novalido" : ""}>
                                              <Input
                                                name="precioUnitarioTot"
                                                value={x.precioUnitarioTot ? x.precioUnitarioTot : ""
                                                }
                                                placeholder=""
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                              />

                                            </Td>
                                            <Td className="">
                                              {x.precioSubTotalSDV ? x.divisaPS + x.precioSubTotalSDV : ""}
                                            </Td>
                                            <Td>{x.descuento ? x.descuento : ""}</Td>
                                            <Td className="">
                                              {x.precioTotal ? x.precioTotal : ""}
                                            </Td>
                                            {/*<Td className="margintopmobil20px">
                                              <Button
                                                className=" "
                                                title="Eliminar registro"
                                                size="sm"
                                                color="danger"
                                                onClick={() =>
                                                  "setInputList(handleRemoveClick(i, [...inputList,]))"
                                                }
                                              >
                                                <IoIcons.IoMdClose />
                                              </Button>
                                              </Td>*/}
                                          </Tr>
                                        )
                                    )}
                                  </Tbody>
                                </Table>
                              </div>
                            </Row>
                            {inputListServicios.length > 0 && (
                              <Row>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px " >
                                  <h5 className="floatleft">Servicios extra</h5>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 margintop20px " >
                                  <button className={" cbutton btn-success floatright "} color="success" size="sm" title="Agregar datos nuevos"
                                    onClick={(e) =>
                                      setInputListServicios(handleAddClick([...inputListServicios], { ...serviciosIniciales, createdAt: new Date() }))
                                    }> <span className="fa fa-plus"> Servicios extra</span> </button>
                                </div>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                  <Table className=" mb-2  ">
                                    <Thead class="thead-secondary">
                                      <Tr>
                                        <Th>Quantity*</Th>
                                        <Th className="">
                                          Description*
                                        </Th>
                                        <Th className="">
                                          Unit price*
                                        </Th>
                                        <Th>Total* </Th>
                                        <Th className=""> Eliminar </Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {inputListServicios.map(
                                        (x, i) =>
                                          //x.activo && (
                                          <Tr
                                            className={
                                              i % 2 !== 0 ? "table-active" : ""
                                            }
                                          >
                                            <Td className={datosIncompletos === true && !x.quantity ? "novalido" : ""}>
                                              <Input
                                                name="quantity"
                                                value={x.quantity ? x.quantity : ""
                                                }
                                                placeholder=""
                                                onChange={(e) =>
                                                  setInputListServicios(
                                                    handleInputChangeServicios(e, i, [
                                                      ...inputListServicios,
                                                    ])
                                                  )
                                                }
                                              />

                                            </Td>
                                            <Td className={datosIncompletos === true && !x.description ? "novalido" : ""}>
                                              <Input
                                                name="description"
                                                value={x.description ? x.description : ""
                                                }
                                                placeholder=""
                                                onChange={(e) =>
                                                  setInputListServicios(
                                                    handleInputChangeServicios(e, i, [
                                                      ...inputListServicios,
                                                    ])
                                                  )
                                                }
                                              />

                                            </Td>
                                            <Td className={datosIncompletos === true && !x.uprice ? "novalido" : ""}>
                                              <Input
                                                name="uprice"
                                                value={x.uprice ? x.uprice : ""
                                                }
                                                placeholder=""
                                                onChange={(e) =>
                                                  setInputListServicios(
                                                    handleInputChangeServicios(e, i, [
                                                      ...inputListServicios,
                                                    ])
                                                  )
                                                }
                                              />

                                            </Td>
                                            <Td className="">
                                              {x.total ? "$" + x.total : ""}
                                            </Td>
                                            {<Td className="margintopmobil20px">
                                              <Button
                                                className=" "
                                                title="Eliminar registro"
                                                size="sm"
                                                color="danger"
                                                onClick={() =>
                                                  setInputListServicios(handleRemoveClick(i, [...inputListServicios,]))
                                                }
                                              >
                                                <IoIcons.IoMdClose />
                                              </Button>
                                            </Td>}
                                          </Tr>
                                        // )
                                      )}
                                    </Tbody>
                                  </Table>
                                </div>
                              </Row>
                            )}
                            <Row>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                <Button
                                  className="floatright mr-3"
                                  onClick={cancelarFactura}
                                  color="danger"
                                >
                                  Terminar
                                </Button>

                                <Button
                                  className="floatright"
                                  onClick={() => manageFacturacion()}
                                  disabled={isDisabled}
                                  color="primary"
                                >
                                  {editar === true ? "Guardar Cambios" : "Generar Invoice"}
                                </Button>
                              </div>
                            </Row>
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(inputListServicios)}</div>*/}
                          </>
                        )}
                        {/*JSON.stringify(embarqueSerialEditar)*/}
                      </>
                    )}
                    {tituloTab === "Detalle de embarque" && (
                      <>
                        <Row>
                          {pfacturacion && (
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatleft">
                              <h5 className="floatleft">INVOICE ID {invoiceID}</h5>
                            </div>
                          )}
                          <div
                            className={
                              pfacturacion
                                ? "col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop10px floatright"
                                : "col-lg-12 col-md-12 col-sm-12 col-xs-12  margintop10px floatright"
                            }
                          >
                            <button
                              class="btn-info cbutton floatright "
                              onClick={cancelarFactura}
                              title="Regresar"
                            >
                              <IoIcons.IoMdArrowRoundBack />
                              Regresar{" "}
                            </button>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                            <div className="textaligmentleft">
                              {" "}
                              <h5>Datos generales</h5>
                            </div>
                            <Table className="margintop20px mb-2  ">
                              <Thead class="thead-secondary">
                                <Tr>
                                  <Th>Packing ID</Th>
                                  <Th className="minwidth100px">Fecha</Th>
                                  <Th className="minwidth100px">
                                    Cliente de recepción
                                  </Th>
                                  <Th className="minwidth100px">
                                    Cliente de entrega
                                  </Th>
                                  <Th className="minwidth100px">Facturar a</Th>
                                  <Th className="minwidth100px">
                                    En atencion a
                                  </Th>
                                  <Th>
                                    {rCliente === "Olson Internacional"
                                      ? "Lote"
                                      : "Orden de compra"}
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td>
                                    {inputList[0] ? inputList[0].numero : ""}
                                  </Td>
                                  <Td>{fechaFactura}</Td>
                                  <Td className=""> {rCliente} </Td>
                                  <Td className=""> {rClienteEntrega} </Td>
                                  <Td className=""> {rClienteFacturarA} </Td>
                                  <Td className="">{"atencionA"} </Td>
                                  <Td className="">{"ordenDeCompra"}</Td>
                                </Tr>
                              </Tbody>
                            </Table>
                          </div>
                        </Row>
                        <Row>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentleft margintop20px">
                            <h5> {servicios == true ? "Detalle factura servicios embarques" : "Detalle"}</h5>
                          </div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                            <Table className="mb-2  ">
                              <Thead class="thead-secondary">
                                <Tr>
                                  <Th>No.</Th>
                                  <Th className="minwidth100px">Cliente</Th>
                                  <Th className="minwidth100px">
                                    Número de parte
                                  </Th>
                                  <Th className="minwidth100px">
                                    Número de parte Embarques
                                  </Th>
                                  <Th className="minwidth100px">Descripción</Th>
                                  <Th>Serial </Th>
                                  <Th>Serial BTI</Th>
                                  <Th>Serial Embarques </Th>
                                  <Th>Nuevo Serial del cliente</Th>
                                  <Th>
                                    {rCliente === "Olson Internacional"
                                      ? "PO:"
                                      : "Lote:"}
                                  </Th>
                                  <Th>
                                    {rCliente === "Olson Internacional"
                                      ? "Line"
                                      : "Packing"}
                                  </Th>
                                  <Th className="minwidth100px">MFG Fecha</Th>
                                  <Th>Comentarios</Th>
                                  <Th>Piezas pintadas</Th>
                                  <Th>Piezas no recuperadas</Th>
                                  <Th>Piezas no pintadas</Th>
                                  <Th className="">Material en:</Th>
                                  <Th className="">Empaques:</Th>
                                  {/*<Th >Barra</Th>
                                  <Th>Imprimir Etiqueta</Th>*/}
                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map(
                                  (x, i) =>
                                    (x.activo || servicios == true) && (
                                      <Tr
                                        className={
                                          i % 2 !== 0 ? "table-active" : ""
                                        }
                                      >
                                        <Td>{x.orden}</Td>
                                        <Td>{x.cliente}</Td>
                                        <Td className="">{x.numerodeParte}</Td>
                                        <Td className="">
                                          {x.numerodeParteSalida}
                                        </Td>
                                        <Td
                                          className={
                                            !x.numerodeParteSalida
                                              ? "margintopmobil20px"
                                              : ""
                                          }
                                        >
                                          {x.descripcion}
                                        </Td>
                                        <Td
                                          className={
                                            !x.descripcion
                                              ? "margintopmobil20px"
                                              : ""
                                          }
                                        >
                                          {x.serial}
                                        </Td>
                                        <Td className="">
                                          {x.serialRecibaBTI}
                                        </Td>
                                        <Td className="">{x.numeroSerial}</Td>
                                        <Td className="">
                                          {x.serialNRecuperado}
                                        </Td>
                                        <Td className="">
                                          {rCliente === "Olson Internacional"
                                            ? x.po
                                            : x.lote}
                                        </Td>
                                        <Td className="">{x.packing}</Td>
                                        <Td className="">{x.MFGFecha}</Td>
                                        <Td className=""> {x.comentarios} </Td>
                                        <Td className="">{x.piezasPintadas}</Td>
                                        <Td className="">
                                          {x.piezasNRecuperadas > 0
                                            ? x.piezasNRecuperadas
                                            : ""}
                                        </Td>
                                        <Td className={
                                          x.piezasNRecuperadas > 0
                                            ? ""
                                            : "margintopmobil20px"
                                        }>
                                          {x.piezasNoPintadas > 0
                                            ? x.piezasNoPintadas
                                            : ""}
                                        </Td>
                                        <Td
                                          className={
                                            x.piezasNoPintadas > 0
                                              ? ""
                                              : "margintopmobil20px"
                                          }
                                        >
                                          {x.materialEn}
                                        </Td>
                                        <Td className={"margintopmobil0px"}>
                                          {x.materialEnCantidad}{" "}
                                        </Td>
                                        {/*<Td><Bargenerator data={x.serial} /></Td>
                                        <Td>
                                          <button
                                            class="btn-warning cbutton mt-1 ml-1"
                                            title="Etiqueta viajera"
                                            onMouseDown={() =>
                                              setIndexImp(i + 1)
                                            }
                                            onClick={() =>
                                              " clicImprimirEtiqueta(x)"
                                            }
                                          >
                                            {" "}
                                            <IoIcons.IoIosPrint />{" "}
                                          </button>
                                        </Td>*/}
                                      </Tr>
                                    )
                                )}
                              </Tbody>
                            </Table>
                          </div>
                        </Row>
                        <div style={{ display: "none" }}>
                          <div ref={componentRefTEV}>
                            {inputList.map((x, i) => {
                              return (
                                x.activo && (
                                  <div ref={componentRef[i + 1]}>
                                    {(x.piezasPintadas ? x.piezasPintadas : 0) >
                                      0 && (
                                        <div className="page-breaksmtop">
                                          <Row>
                                            <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                                              <img
                                                className="imgmaretiqueta"
                                                src="assets/img/Logo/logon.png"
                                              />
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                                              <h1 class=" textaligmentcenter fontblackbold ">
                                                BOON TEC INTERNATIONAL, S. de R.L.
                                                de C.V.
                                              </h1>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                                              <h3 class="  textaligmentcenter  fontblackbold ">
                                                Norte 2 #14, Fracc. Cd.
                                                Industrial.H. Matamoros, Mexico CP
                                                87499
                                              </h3>
                                            </div>
                                          </Row>
                                          <div>
                                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                              <Table bordered className=" ">
                                                <Thead>
                                                  <Tr>
                                                    <Th></Th>
                                                    <Th></Th>
                                                  </Tr>
                                                </Thead>
                                                <Tbody>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PART NO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold subrayado">
                                                        {x.numerodeParteSalida
                                                          ? x.numerodeParteSalida
                                                          : x.numerodeParte}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  {x.cliente !=
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            DESCRIPTION:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.descripcion}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  {x.cliente ===
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            LINE/REL:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.packing}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        MFG DATE:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.MFGFecha}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        QUANTITY:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.piezasPintadas}
                                                      </p>
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        LOT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.lote}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.po}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        CLIENT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.clienteEntrega}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        SERIAL NUMBER:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.serial}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                </Tbody>
                                              </Table>
                                            </div>
                                          </div>
                                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter mt-3">
                                            <Bargenerator data={x.numeroSerial} />
                                          </div>
                                        </div>
                                      )}
                                    {((x.piezasNRecuperadas
                                      ? x.piezasNRecuperadas
                                      : 0) > 0 ||
                                      (x.piezasNoPintadas
                                        ? x.piezasNoPintadas
                                        : 0) > 0) && (
                                        <div className="page-breaksmtop">
                                          <Row>
                                            <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                                              <img
                                                className="imgmaretiqueta"
                                                src="assets/img/Logo/logon.png"
                                              />
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                                              <h1 class=" textaligmentcenter fontblackbold ">
                                                BOON TEC INTERNATIONAL, S. de R.L.
                                                de C.V.
                                              </h1>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                                              <h3 class="  textaligmentcenter  fontblackbold ">
                                                Norte 2 #14, Fracc. Cd.
                                                Industrial.H. Matamoros, Mexico CP
                                                87499
                                              </h3>
                                            </div>
                                          </Row>
                                          <div>
                                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                              <Table bordered className=" ">
                                                <Thead>
                                                  <Tr>
                                                    <Th></Th>
                                                    <Th></Th>
                                                  </Tr>
                                                </Thead>
                                                <Tbody>
                                                  <Tr>
                                                    <Td
                                                      colspan="2"
                                                      className="fontsize50px textaligmentcenter"
                                                    >
                                                      <Label className="fontblackbold">
                                                        MATERIAL NO CONFORME
                                                      </Label>
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PART NO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold subrayado">
                                                        {x.numerodeParteSalida
                                                          ? x.numerodeParteSalida
                                                          : x.numerodeParte}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  {x.cliente !=
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            DESCRIPTION:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.descripcion}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  {x.cliente ===
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            LINE/REL:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.packing}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        MFG DATE:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.MFGFecha}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        QUANTITY:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {(x.piezasNRecuperadas
                                                          ? x.piezasNRecuperadas
                                                          : 0) +
                                                          (x.piezasNoPintadas
                                                            ? x.piezasNoPintadas
                                                            : 0)}
                                                      </p>
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        LOT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.lote}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.po}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        CLIENT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.clienteEntrega}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        SERIAL NUMBER:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.serial}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                </Tbody>
                                              </Table>
                                            </div>
                                          </div>
                                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter mt-3">
                                            <Bargenerator data={x.numeroSerial} />
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )
                              );
                            })}
                          </div>
                        </div>
                      </>
                    )}
                  </TabPane>
                  <TabPane tabId="4">
                    <div ref={componentRefTEV}>
                      <div ref={componentRef[0]}>
                        <Row>
                          <img
                            className="imgmarlimpf"
                            src="assets/img/Logo/logost.png"
                          />
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmentcenter">
                            <h5 class="floatright fontsizeN20px">
                              Boon tec International S de RL de CV
                            </h5>
                            <h5 class=" floatright fontsize20px ">
                              We keep your chain going, any day, any time"
                            </h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmentcenter">
                            <h5 class="floatright fontsize25Bpx mr-3">
                              INVOICE
                            </h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmenleft">
                            <h5 class=" fontsizeN20px ml-3">
                              Boon Tec International
                            </h5>
                            <h5 class=" fontsizeN20px margintop-6px ml-3 ">
                              7728 Padre Island Hwy
                            </h5>
                            <h5 class=" fontsizeN20px margintop-6px ml-3">
                              Brownsville Texas 78521
                            </h5>
                            <h5 class="fontsizeN20px margintop-6px ml-3">
                              Phone: 956 656 0481
                            </h5>
                            <h5 class="fontsizeN20px margintop-6px ml-3">
                              TAX ID: BTI180403MA2
                            </h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmenright">
                            <h5 class="margintop-6px mr-3">
                              Invoice #: {invoiceID}
                            </h5>
                            <h5 class="margintop-6px mr-3">
                              Date:  {Moment(fechaFactura).format("MMMM DD, YYYY")}
                            </h5>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px fontsizeN20px  textaligmenleft">
                            <h5 class="  ml-3 fontsizeN20px ">
                              Bill To:
                            </h5>
                            <h5 class="margintop-6px ml-3 fontsizeN20px">
                              {billTo}
                            </h5>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px fontsizeN20px  textaligmenleft">
                            <h5 class=" ml-3 fontsizeN20px ">
                              Ship To:
                            </h5>
                            <h5 class="margintop-6px ml-3 fontsizeN20px">
                              {shipTo}
                            </h5>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px   textaligmenleft"></div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6   fontsize20px textaligmenleft">
                            <h5 class="  ml-3 margintop20px">
                              Comments or special instructions :
                            </h5>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop20px   textaligmenleft ml-3">
                            <h5 class="margintop-6px floatleft">
                              _____________________________________________________________________________________________________________________________________________
                            </h5>
                            <h5 class="margintop-6px floatleft">
                              _____________________________________________________________________________________________________________________________________________
                            </h5>
                            <h5 class="margintop-6px floatleft">
                              _____________________________________________________________________________________________________________________________________________
                            </h5>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-92px   textaligmenleft ml-3">
                            <h5 class=" floatleft">
                              {comentariosFacturacion}
                            </h5>

                          </div>
                        </Row>
                        <div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Table
                              bordered
                              className="margintop20px mb-2  fontsize20px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                    SALESPERSON
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    SUPPLIER P.O. NUMBER
                                  </Th>
                                  {/*<Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">Lote</Th>*/}
                                  <Th className={rCliente === "Olson Internacional" ? "thtableImprimir fontsize20px textaligmentcenter" : "displaynone thtableImprimir fontsize20px textaligmentcenter"}>
                                    PO
                                  </Th>
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    REQUISITIONER
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    SHIPPED VIA{/*invoiceID.substr(5, 2) === "RS" ? "DATE" : "SHIPPED VIA"*/}
                                  </Th>
                                  <Th className="minwidth60px thtableImprimir fontsize20px textaligmentcenter">
                                    DUE DATE
                                  </Th>
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    CAS Quote #
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>

                                <Tr>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {salesPerson}
                                  </Td>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {poNumber}
                                  </Td>
                                  <Td className={rCliente === "Olson Internacional" ? "fontsize20px textaligmentcenter " : "displaynone fontsize20px textaligmentcenter"}>{posS}</Td>
                                  {/*<Td className="fontsize20px textaligmentcenter">{embarquess.lote}</Td>*/}
                                  <Td className="fontsize20px textaligmentcenter">
                                    {requisitioner}
                                  </Td>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {invoiceID.substr(5, 2) === "RS" ? Moment(fechaFactura).format("MMMM DD, YYYY") : "Email"}
                                  </Td>
                                  <Td className={"fontsize20px textaligmentcenter"}>
                                    {Moment(dueDate).format("MMMM DD, YYYY")}
                                  </Td>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {casQuote}
                                  </Td>
                                </Tr>

                              </Tbody>
                            </Table>


                          </div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Table
                              bordered
                              className="margintop20px mb-2  fontsize20px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                    Quantity
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    Part Number
                                  </Th>
                                  {/*<Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">Lote</Th>*/}
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    Serial
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    {rCliente === "Olson Internacional"
                                      ? "LINE"
                                      : "SHIPPER"}
                                  </Th>
                                  <Th className="minwidth60px thtableImprimir fontsize20px textaligmentcenter">
                                    Pieces
                                  </Th>

                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    Unit price
                                  </Th>
                                  {facturaDescuentoP && (
                                    <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                      Discount
                                    </Th>
                                  )}
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    Total
                                  </Th>

                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map(
                                  (embarquess, i) =>
                                    i < 28 && (
                                      <Tr>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.materialEnCantidad}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.numerodeParteSalida
                                            ? embarquess.numerodeParteSalida
                                            : embarquess.numerodeParte}
                                        </Td>
                                        {/*<Td className="fontsize20px textaligmentcenter">{embarquess.lote}</Td>*/}
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.serialNRecuperado
                                            ? embarquess.serialNRecuperado
                                            : embarquess.serial}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.packing}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.piezasPintadas +
                                            (embarquess.piezasPintadasExtra ? embarquess.piezasPintadasExtra : 0) +
                                            (parseInt(sinTotalScrapFactura === true ? 0 : (embarquess.piezasNRecuperadas ? embarquess.piezasNRecuperadas : 0)))}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {(embarquess.divisa === "Peso mexicano" ||
                                            embarquess.divisa === "Dólar" ? "$" : "€") + embarquess.precioUnitarioTot}
                                        </Td>
                                        {facturaDescuentoP && (
                                          <Td className="fontsize20px textaligmentcenter">
                                            {embarquess.descuento}
                                          </Td>
                                        )}
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.divisaPS + embarquess.precioSubTotalSDV}
                                        </Td>
                                      </Tr>
                                    )
                                )}
                              </Tbody>
                            </Table>

                            {(inputList.length > 27) && (
                              <>
                                <div className="page-break">
                                  <Table
                                    bordered
                                    className=" mb-2  fontsize20px "
                                  >
                                    <Thead>
                                      <Tr>
                                        <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                          Quantity
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                          Part Number
                                        </Th>
                                        {/*<Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">Lote</Th>*/}
                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Serial
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                          {rCliente === "Olson Internacional"
                                            ? "LINE"
                                            : "SHIPPER"}
                                        </Th>
                                        <Th className="minwidth60px thtableImprimir fontsize20px textaligmentcenter">
                                          Pieces
                                        </Th>

                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Unit price
                                        </Th>
                                        {facturaDescuentoP && (
                                          <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                            Discount
                                          </Th>
                                        )}
                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Total
                                        </Th>

                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {inputList.map(
                                        (embarquess, i) =>
                                          (i > 27 && i < 75) && (
                                            <Tr>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.materialEnCantidad}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.numerodeParteSalida
                                                  ? embarquess.numerodeParteSalida
                                                  : embarquess.numerodeParte}
                                              </Td>
                                              {/*<Td className="fontsize20px textaligmentcenter">{embarquess.lote}</Td>*/}
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.serialNRecuperado
                                                  ? embarquess.serialNRecuperado
                                                  : embarquess.serial}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.packing}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.piezasPintadas +
                                                  (embarquess.piezasPintadasExtra ? embarquess.piezasPintadasExtra : 0) +
                                                  (parseInt(sinTotalScrapFactura === true ? 0 : (embarquess.piezasNRecuperadas ? embarquess.piezasNRecuperadas : 0)))}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {(embarquess.divisa === "Peso mexicano" ||
                                                  embarquess.divisa === "Dólar" ? "$" : "€") + embarquess.precioUnitarioTot}
                                              </Td>
                                              {facturaDescuentoP && (
                                                <Td className="fontsize20px textaligmentcenter">
                                                  {embarquess.descuento}
                                                </Td>
                                              )}
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.divisaPS + embarquess.precioSubTotalSDV}
                                              </Td>
                                            </Tr>
                                          )
                                      )}
                                    </Tbody>
                                  </Table>
                                </div>
                              </>
                            )}
                            {(inputList.length > 74) && (
                              <>
                                <div className="page-break">
                                  <Table
                                    bordered
                                    className=" mb-2  fontsize20px "
                                  >
                                    <Thead>
                                      <Tr>
                                        <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                          Quantity
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                          Part Number
                                        </Th>
                                        {/*<Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">Lote</Th>*/}
                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Serial
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                          {rCliente === "Olson Internacional"
                                            ? "LINE"
                                            : "SHIPPER"}
                                        </Th>
                                        <Th className="minwidth60px thtableImprimir fontsize20px textaligmentcenter">
                                          Pieces
                                        </Th>

                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Unit price
                                        </Th>
                                        {facturaDescuentoP && (
                                          <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                            Discount
                                          </Th>
                                        )}
                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Total
                                        </Th>

                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {inputList.map(
                                        (embarquess, i) =>
                                          (i > 74) && (
                                            <Tr>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.materialEnCantidad}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.numerodeParteSalida
                                                  ? embarquess.numerodeParteSalida
                                                  : embarquess.numerodeParte}
                                              </Td>
                                              {/*<Td className="fontsize20px textaligmentcenter">{embarquess.lote}</Td>*/}
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.serialNRecuperado
                                                  ? embarquess.serialNRecuperado
                                                  : embarquess.serial}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.packing}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.piezasPintadas +
                                                  (embarquess.piezasPintadasExtra ? embarquess.piezasPintadasExtra : 0) +
                                                  (parseInt(sinTotalScrapFactura === true ? 0 : (embarquess.piezasNRecuperadas ? embarquess.piezasNRecuperadas : 0)))}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {(embarquess.divisa === "Peso mexicano" ||
                                                  embarquess.divisa === "Dólar" ? "$" : "€") + embarquess.precioUnitarioTot}
                                              </Td>
                                              {facturaDescuentoP && (
                                                <Td className="fontsize20px textaligmentcenter">
                                                  {embarquess.descuento}
                                                </Td>
                                              )}
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.divisaPS + embarquess.precioSubTotalSDV}
                                              </Td>
                                            </Tr>
                                          )
                                      )}
                                    </Tbody>
                                  </Table>
                                </div>
                              </>
                            )}
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 mt-2   ">
                            <h5 class="floatleft  margintop20px    ">
                              Total:{" "}
                            </h5>
                            <h5 class="floatright margintop20px">
                              SUB-TOTAL: {sumSubTotal}
                            </h5>
                          </div>
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1   ">
                              {sumCajas > 0 && (
                                <h5 class="floatleft margintop13px">
                                  {sumCajas + (sumCajas ? sumCajas > 1 ? " Boxes" : " Box" : "")}
                                </h5>
                              )}
                            </div>
                          </Row>
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-2">
                              {sumContenedores > 0 && (
                                <h5
                                  class={
                                    sumCajas > 0
                                      ? " marginleft165px margintop-20px"
                                      : ""
                                  }
                                >
                                  {" "}
                                  {sumContenedores + (sumContenedores ? sumContenedores > 1 ? " Containers" : " Container" : "")}
                                </h5>
                              )}
                            </div>
                          </Row>
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-2   ">
                              {sumTarimas > 0 && (
                                <h5 class={((sumCajas > 0) && (sumContenedores > 0))
                                  ? " marginleft165px margintop-13px"
                                  : (sumContenedores > 0) ? " marginleft165px margintop-10px" :
                                    (sumCajas > 0) ? " marginleft165px margintop-20px" : "margintop-6px"
                                }>
                                  {sumTarimas + (sumTarimas ? sumTarimas > 1 ? " Platforms" : " Platform" : "")}
                                </h5>
                              )}
                            </div>
                          </Row>
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 mb-1">
                              <h5 class="floatright mr-3">
                                {(facturaDescuentoP ? facturaDescuentoP : "") + "% OFF: " + sumTotalDes}
                              </h5>
                            </div>
                          </Row>
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 mb-1   ">
                              <h5 class="floatright mr-3">
                                TOTAL due: {sumTotal}
                              </h5>
                            </div>
                          </Row>
                          {totalNumeroParte.length > 0 && (
                            <Row className="margintop20px">
                              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                <Table
                                  bordered
                                  className="margintop20px mb-2  fontsize18px "
                                >
                                  <Thead>
                                    <Tr>
                                      <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                        Quantity
                                      </Th>
                                      <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                        Part Number
                                      </Th>
                                      <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                        Pieces
                                      </Th>
                                      <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                        Sub-Total
                                      </Th>
                                      <Th className=" thtableImprimir fontsize18px textaligmentcenter">
                                        Discount
                                      </Th>
                                      <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                        Total
                                      </Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {totalNumeroParte.map(
                                      (embarquess, i) =>
                                        i < 34 && (
                                          <Tr>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.totalCantidad}
                                            </Td>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.numerodeParteSalida
                                                ? embarquess.numerodeParteSalida
                                                : embarquess.numerodeParte}
                                            </Td>
                                            {/*<Td className="fontsize18px textaligmentcenter">{embarquess.lote}</Td>*/}
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.totalNumeroParte}
                                            </Td>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.subTotNP}
                                            </Td>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.desTotNP}
                                            </Td>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.totNP}
                                            </Td>
                                          </Tr>
                                        )
                                    )}
                                  </Tbody>
                                </Table>

                                {totalNumeroParte.length > 33 && (
                                  <>
                                    <div className="page-break">
                                      <Table
                                        bordered
                                        className=" mb-2  fontsize18px "
                                      >
                                        <Thead>
                                          <Tr>
                                            <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                              Quantity
                                            </Th>
                                            <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                              Part Number
                                            </Th>
                                            <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                              Pieces
                                            </Th>
                                            <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                              Sub-Total
                                            </Th>
                                            <Th className=" thtableImprimir fontsize18px textaligmentcenter">
                                              Discount
                                            </Th>
                                            <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                              Total
                                            </Th>
                                          </Tr>
                                        </Thead>
                                        <Tbody>
                                          {totalNumeroParte.map(
                                            (embarquess, i) =>
                                              i > 33 && (
                                                <Tr>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.totalCantidad}
                                                  </Td>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.numerodeParteSalida
                                                      ? embarquess.numerodeParteSalida
                                                      : embarquess.numerodeParte}
                                                  </Td>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.totalNumeroParte}
                                                  </Td>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.subTotNP}
                                                  </Td>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.desTotNP}
                                                  </Td>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.totNP}
                                                  </Td>
                                                </Tr>
                                              )
                                          )}
                                        </Tbody>
                                      </Table>
                                    </div>
                                  </>
                                )}
                              </div>
                            </Row>
                          )}
                          <div className="page-break">
                            <div class="margintop-150px ">
                              <h5 class="textaligmentleft ">
                                Please send payment
                              </h5>
                              <h5 class="textaligmentleft ">
                                VIA ACH to Boon Tec International S de RL de CV
                              </h5>
                              <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2 ">
                                  <h5>
                                    <h5 class="textaligmentcenter fontsizeN30px margintop20px">Customer Satisfaction Survey </h5>
                                    <h5 class="textaligmentcenter fontsize20px margintop30px">AS OUR VALUED CUSTOMER, Containment Assistance & Services de Mexico appreciates your</h5>
                                    <h5 class="textaligmentcenter fontsize20px">business and will make any effort to improve the ability to provide a Continuously Improved Service to</h5>
                                    <h5 class="textaligmentcenter fontsize20px">Your organization</h5>
                                    <h5 class="textaligmentcenter fontsize20px">On that effort we require you take time to help us sharing your inputs about our Service by</h5>
                                    <h5 class="textaligmentcenter fontsize20px">completing this Short Survey, so that we can implement appropriate measures to improve our</h5>
                                    <h5 class="textaligmentcenter fontsize20px">performance and methods.</h5>
                                    <h5 class="textaligmentcenter fontsize20px">Thank you in Advance !!!</h5>
                                    <h5 class="textaligmentcenter fontsize20px">Boon Tec International S de RL de CV, Sales and Customer Care</h5>
                                    <h5 class="textaligmentleft margintop30px fontsize20px">1.- On your perception, How was the Service performed in general?</h5>
                                    <h5 class="textaligmentleft margintop20px  fontsize20px">
                                      <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Non OK
                                    </h5>
                                    <h5 class="textaligmentleft margintop30px  fontsize20px">2.- Have the Orders/Materials been provided in a "On time Delivery"?</h5>
                                    <h5 class="textaligmentleft margintop20px  fontsize20px">
                                      <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Non OK
                                    </h5>
                                    <h5 class="textaligmentleft margintop30px  fontsize20px">3.- Is BTI your first option for ecoat your parts next time?</h5>
                                    <h5 class="textaligmentleft margintop20px  fontsize20px">
                                      <span class="dot"></span> &nbsp; Yes &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; No, but I will if..____________________________________________________________________________________________________________
                                    </h5>
                                    <h5 class="margintop10px floatleft">
                                      ______________________________________________________________________________________________________________________________________________
                                    </h5>
                                    <h5 class="textaligmentleft margintop30px  fontsize20px">4.- Is the Cost per part competitive compared with other options?</h5>
                                    <h5 class="textaligmentleft margintop20px  fontsize20px">
                                      <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Non OK
                                    </h5>
                                    <h5 class="textaligmentleft margintop30px  fontsize20px">5.- Was the quote clear, accurate and well documented including in time delivery?</h5>
                                    <h5 class="textaligmentleft margintop20px  fontsize20px">
                                      <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Non OK
                                    </h5>
                                    <h5 class="textaligmentleft margintop30px  fontsize20px">6.-  Is the Invoice Service accurate, fear and well documented?</h5>
                                    <h5 class="textaligmentleft margintop20px  fontsize20px">
                                      <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                      <span class="dot"></span> &nbsp; Non OK
                                    </h5>
                                  </h5>

                                  <h5 class="margintop30px  fontsize20px textaligmentcenter">
                                    Additional comments, or additional services are you interested from Boon Tec International S de RL de CV if any:
                                  </h5>

                                  <h5 class=" floatleft margintop20px">
                                    _____________________________________________________________________________________________________________________________________________
                                  </h5>
                                  <h5 class="margintop10px floatleft">
                                    _____________________________________________________________________________________________________________________________________________
                                  </h5>
                                  <h5 class="margintop10px floatleft">
                                    _____________________________________________________________________________________________________________________________________________
                                  </h5>
                                </div>
                              </Row>
                              <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5 ">
                                  <h5 class="textaligmentleft   fontsize20px">
                                    Customer Contact : ____________________________________________________________________________________
                                  </h5>
                                  <h5 class="textaligmentleft  margintop10px fontsize20px">
                                    Company : _____________________________________________________________________________________________
                                  </h5>
                                  <h5 class="textaligmentleft  margintop10px fontsize20px">
                                    Date : __________________________________________________________________________________________________
                                  </h5>
                                </div>
                              </Row>
                              <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5 ">
                                  <h5 class="textaligmentcenter  fontsize20px">
                                    _______________________________________________________________
                                  </h5>
                                  <h5 class="textaligmentcenter  margintop-10px fontsize20px">
                                    Signature
                                  </h5>
                                </div>
                              </Row>
                            </div>
                          </div>
                          <div class="footer">
                            <p className="floatright margintop-16px mr-3">Doc ID: FOR-VE05</p> <br />
                            <p className="floatright margintop-16px mr-3">Revision : 1</p> <br />
                            <p className="floatright margintop-16px mr-3">Fecha: 15/Nov/2014</p>

                          </div>
                        </div>
                      </div>
                      <div ref={componentRef[1]}>
                        <Row>
                          <img
                            className="imgmarlimpf"
                            src="assets/img/Logo/logost.png"
                          />
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmentcenter">
                            <h5 class="floatright fontsizeN20px">
                              Boon tec International S de RL de CV
                            </h5>
                            <h5 class=" floatright fontsize20px ">
                              We keep your chain going, any day, any time"
                            </h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmentcenter">
                            <h5 class="floatright fontsize25Bpx mr-3">
                              INVOICE
                            </h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmenleft">
                            <h5 class=" fontsizeN20px ml-3">
                              Boon Tec International
                            </h5>
                            <h5 class=" fontsizeN20px margintop-6px ml-3 ">
                              7728 Padre Island Hwy
                            </h5>
                            <h5 class=" fontsizeN20px margintop-6px ml-3">
                              Brownsville Texas 78521
                            </h5>
                            <h5 class="fontsizeN20px margintop-6px ml-3">
                              Phone: 956 656 0481
                            </h5>
                            <h5 class="fontsizeN20px margintop-6px ml-3">
                              TAX ID: BTI180403MA2
                            </h5>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmenright">
                            <h5 class="margintop-6px mr-3">
                              Invoice #: {invoiceID}-1
                            </h5>
                            <h5 class="margintop-6px mr-3">
                              Date:  {Moment(fechaFactura).format("MMMM DD, YYYY")}
                            </h5>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px fontsizeN20px  textaligmenleft">
                            <h5 class="  ml-3 fontsizeN20px ">
                              Bill To:
                            </h5>
                            <h5 class="margintop-6px ml-3 fontsizeN20px">
                              {billTo}
                            </h5>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px fontsizeN20px  textaligmenleft">
                            <h5 class=" ml-3 fontsizeN20px ">
                              Ship To:
                            </h5>
                            <h5 class="margintop-6px ml-3 fontsizeN20px">
                              {shipTo}
                            </h5>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px   textaligmenleft"></div>
                          <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6   fontsize20px textaligmenleft">
                            <h5 class="  ml-3 margintop20px">
                              Comments or special instructions :
                            </h5>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop20px   textaligmenleft ml-3">
                            <h5 class="margintop-6px floatleft">
                              _____________________________________________________________________________________________________________________________________________
                            </h5>
                            <h5 class="margintop-6px floatleft">
                              _____________________________________________________________________________________________________________________________________________
                            </h5>
                            <h5 class="margintop-6px floatleft">
                              _____________________________________________________________________________________________________________________________________________
                            </h5>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-92px   textaligmenleft ml-3">
                            <h5 class=" floatleft">
                              {comentariosFacturacion}
                            </h5>

                          </div>
                        </Row>
                        <div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Table
                              bordered
                              className="margintop20px mb-2  fontsize20px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                    SALESPERSON
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    SUPPLIER P.O. NUMBER
                                  </Th>
                                  {/*<Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">Lote</Th>*/}
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    REQUISITIONER
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    SHIPPED VIA{/*invoiceID.substr(5, 2) === "RS" ? "DATE" : "SHIPPED VIA"*/}
                                  </Th>
                                  <Th className="minwidth60px thtableImprimir fontsize20px textaligmentcenter">
                                    DUE DATE
                                  </Th>
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    CAS Quote #
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>

                                <Tr>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {salesPerson}
                                  </Td>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {poNumber}
                                  </Td>
                                  {/*<Td className="fontsize20px textaligmentcenter">{embarquess.lote}</Td>*/}
                                  <Td className="fontsize20px textaligmentcenter">
                                    {requisitioner}
                                  </Td>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {invoiceID.substr(5, 2) === "RS" ? Moment(fechaFactura).format("MMMM DD, YYYY") : "Email"}
                                  </Td>
                                  <Td className={"fontsize20px textaligmentcenter"}>
                                    {Moment(dueDate).format("MMMM DD, YYYY")}
                                  </Td>
                                  <Td className="fontsize20px textaligmentcenter">
                                    {casQuote}
                                  </Td>
                                </Tr>

                              </Tbody>
                            </Table>


                          </div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Table
                              bordered
                              className="margintop20px mb-2  fontsize20px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                    Quantity
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                    Description
                                  </Th>
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    Unit price (U$D)
                                  </Th>
                                  <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                    Total
                                  </Th>

                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputListServicios.map(
                                  (embarquess, i) =>
                                    i < 28 && (
                                      <Tr>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.quantity}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {embarquess.description}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {"$" + embarquess.uprice}
                                        </Td>
                                        <Td className="fontsize20px textaligmentcenter">
                                          {"$" + embarquess.total}
                                        </Td>
                                      </Tr>
                                    )
                                )}
                              </Tbody>
                            </Table>

                            {inputListServicios.length > 33 && (
                              <>
                                <div className="page-break">
                                  <Table
                                    bordered
                                    className=" mb-2  fontsize20px "
                                  >
                                    <Thead>
                                      <Tr>
                                        <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                          Quantity
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                          Description
                                        </Th>
                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Unit price (U$D)
                                        </Th>
                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                          Total
                                        </Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {inputListServicios.map(
                                        (embarquess, i) =>
                                          i > 33 && (
                                            <Tr>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.quantity}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {embarquess.description}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {"$" + embarquess.uprice}
                                              </Td>
                                              <Td className="fontsize20px textaligmentcenter">
                                                {"$" + embarquess.total}
                                              </Td>
                                            </Tr>
                                          )
                                      )}
                                    </Tbody>
                                  </Table>
                                </div>
                              </>
                            )}
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1   ">
                            <h5 class="floatright margintop20px">
                              Total due: ${sumTotalServicio}
                            </h5>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 margintop100px ">
                            <p class="textaligmentcenter fontsize18px">
                              A CUSTOMER SATISFACTION SURVEY SHALL BE SEND TO OUR CUSTOMER AT INVOICING
                            </p>
                            <p class="textaligmencenter fontsize18px margintop-6px">
                              A COMPLETED CUSTOMER SATISFACTION SURVEY SHOULD BE ON FILE AT LEAST QUATERLY FOR RECENT CUSTOMERS/ SERVICES
                            </p>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 margintop100px ">
                            <h5 class="textaligmentleft fontsizeN20px">
                              Payment Method:
                            </h5>
                            <h5 class="textaligmentleft fontsizeN20px margintop-6px">
                              Please make a check to:
                            </h5>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 margintop100px ">
                            <h5 class="textaligmentleft fontsizeN20px">
                              Mailling Address:
                            </h5>
                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                              Magdaleno Flores
                            </h5>
                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                              7728 Padre Island Highway
                            </h5>
                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                              Brownsville Texas 78521
                            </h5>
                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                              PH 512 686 1707
                            </h5>
                          </div>
                          <div className="page-break">
                            <Row>
                              <div class="col-lg-12 col-md-12 col-sm-12 mt-2 ">
                                <h5>
                                  <h5 class="textaligmentcenter fontsizeN30px margintop20px">Customer Satisfaction Survey </h5>
                                  <h5 class="textaligmentcenter fontsize20px margintop30px">AS OUR VALUED CUSTOMER, Containment Assistance & Services de Mexico appreciates your</h5>
                                  <h5 class="textaligmentcenter fontsize20px">business and will make any effort to improve the ability to provide a Continuously Improved Service to</h5>
                                  <h5 class="textaligmentcenter fontsize20px">Your organization</h5>
                                  <h5 class="textaligmentcenter fontsize20px">On that effort we require you take time to help us sharing your inputs about our Service by</h5>
                                  <h5 class="textaligmentcenter fontsize20px">completing this Short Survey, so that we can implement appropriate measures to improve our</h5>
                                  <h5 class="textaligmentcenter fontsize20px">performance and methods.</h5>
                                  <h5 class="textaligmentcenter fontsize20px">Thank you in Advance !!!</h5>
                                  <h5 class="textaligmentcenter fontsize20px">Boon Tec International S de RL de CV, Sales and Customer Care</h5>
                                  <h5 class="textaligmentleft margintop30px fontsize20px">1.- On your perception, How was the Service performed in general?</h5>
                                  <h5 class="textaligmentleft margintop20px  fontsize20px">
                                    <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Non OK
                                  </h5>
                                  <h5 class="textaligmentleft margintop30px  fontsize20px">2.- Have the Orders/Materials been provided in a "On time Delivery"?</h5>
                                  <h5 class="textaligmentleft margintop20px  fontsize20px">
                                    <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Non OK
                                  </h5>
                                  <h5 class="textaligmentleft margintop30px  fontsize20px">3.- Is BTI your first option for ecoat your parts next time?</h5>
                                  <h5 class="textaligmentleft margintop20px  fontsize20px">
                                    <span class="dot"></span> &nbsp; Yes &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; No, but I will if..____________________________________________________________________________________________________________
                                  </h5>
                                  <h5 class="margintop10px floatleft">
                                    ______________________________________________________________________________________________________________________________________________
                                  </h5>
                                  <h5 class="textaligmentleft margintop30px  fontsize20px">4.- Is the Cost per part competitive compared with other options?</h5>
                                  <h5 class="textaligmentleft margintop20px  fontsize20px">
                                    <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Non OK
                                  </h5>
                                  <h5 class="textaligmentleft margintop30px  fontsize20px">5.- Was the quote clear, accurate and well documented including in time delivery?</h5>
                                  <h5 class="textaligmentleft margintop20px  fontsize20px">
                                    <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Non OK
                                  </h5>
                                  <h5 class="textaligmentleft margintop30px  fontsize20px">6.-  Is the Invoice Service accurate, fear and well documented?</h5>
                                  <h5 class="textaligmentleft margintop20px  fontsize20px">
                                    <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                    <span class="dot"></span> &nbsp; Non OK
                                  </h5>
                                </h5>

                                <h5 class="margintop30px  fontsize20px textaligmentcenter">
                                  Additional comments, or additional services are you interested from Boon Tec International S de RL de CV if any:
                                </h5>

                                <h5 class=" floatleft margintop20px">
                                  _____________________________________________________________________________________________________________________________________________
                                </h5>
                                <h5 class="margintop10px floatleft">
                                  _____________________________________________________________________________________________________________________________________________
                                </h5>
                                <h5 class="margintop10px floatleft">
                                  _____________________________________________________________________________________________________________________________________________
                                </h5>
                              </div>
                            </Row>
                            <Row>
                              <div class="col-lg-12 col-md-12 col-sm-12 mt-5 ">
                                <h5 class="textaligmentleft   fontsize20px">
                                  Customer Contact : ____________________________________________________________________________________
                                </h5>
                                <h5 class="textaligmentleft  margintop10px fontsize20px">
                                  Company : _____________________________________________________________________________________________
                                </h5>
                                <h5 class="textaligmentleft  margintop10px fontsize20px">
                                  Date : __________________________________________________________________________________________________
                                </h5>
                              </div>
                            </Row>
                            <Row>
                              <div class="col-lg-12 col-md-12 col-sm-12 mt-5 ">
                                <h5 class="textaligmentcenter  fontsize20px">
                                  _______________________________________________________________
                                </h5>
                                <h5 class="textaligmentcenter  margintop-10px fontsize20px">
                                  Signature
                                </h5>
                              </div>
                            </Row>
                          </div>
                        </div>
                        <div class="footer">
                          <p className="floatright margintop-16px mr-3">FOR-VE06 REV B</p> <br />
                        </div>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="5">
                    <FacturacionG />
                  </TabPane>

                </TabContent>
              </div>
            </Fragment>
          </div>
        </>
      )}
    </>
  );
}

export default Facturacion;
